"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import Auth from "../../util/auth";
import Honeybadger from "@honeybadger-io/js";
import React from "react";
import { mergeInvoiceState } from "./merge_invoice_state";
import $ from "jquery";
import _ from "underscore";
import Address from "../../components/address";
import Account from "../../api/account";
import Api from "../../api/api";
import AuditFlagEditor from "../factoring/audit_flag_editor";
import AuditFlagDisplay from "../factoring/audit_flag_display";
import Blocker from "../../components/blocker";
import classNames from "classnames";
import CloseReply from "../close_reply";
import DashboardReturnParams from "../ui/dashboard_return_params";
import { nextCompletionAction } from "./factor_invoice_completion_action";
import DebtorTypeAhead from "../debtor_typeahead";
import BrokeredCarrierTypeAhead from "../brokered_carrier_typeahead";
import DisablingButton from "../../components/disabling_button";
import DocumentBrowser from "../react_document_browser";
import DocumentsService from "../documents_service";
import BrokeredCarrierTermsService from "../brokered_carrier_terms_service";
import GeosuggestDroppableInput from "../geosuggest_dropable_input";
import ExceptionSender from "../exception_sender";
import ExtractedFields from "../factoring/extracted_fields";
import PreviousInvoiceInformation from "./previous_invoice_information";
import FactorBrokersService from "../factor_brokers_service";
import ActionBar from "../factoring/action_bar";
import FactorInvoicesService from "../factor_invoices_service";
import FactorInvoicesStore from "../../stores/factor_invoices_store";
import DataStoreService from "../data_store_service";
import FactorInvoiceUpdateService from "../factor_invoice_update_service";
import generalFormatter from "../../formatters/general";
import InvoiceAbandoner from "../invoice_abandoner";
import LoadEmailCreator from "../load_email_creator";
import loadHelper from "../loads";
import moment from "moment";
import presenceService from "../presence_service_next_gen";
import RemoveFromWaiting from "../remove_from_waiting";
import RulesAndExceptions from "./rules_and_exceptions";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
import TextDroppableInput from "../text_droppable_input";
import WaitingSpinner from "../../components/waiting_spinner";
import {
  GroupedDocumentBrowserModel,
  DocumentBatchGroupCreator
} from "../grouped_document_browser_model";
import { readOnly } from "../../helpers/factor_invoice";
import { escapeRegExp } from "../../util/strings";
import { isImeKey } from "../../util/ime_key";
import { title } from "../../formatters/documents";
import { storeChangedEvent } from "../../stores/object_with_id_store";
import { createPusherInstance } from "../pusher_factory";
import { push } from "../app_history";
import { syncUntrackedInput } from "./sync_untracked_input";
function stripPaddingFromReferences(references) {
  while (!_.isEmpty(references) && s.isBlank(_.last(references))) {
    references.pop();
  }
}
function ensureReferencesHaveCorrectPadding(references) {
  stripPaddingFromReferences(references);
  if (_.isEmpty(references) || !s.isBlank(_.last(references))) {
    var padding = [];
    _.times(2 - references.length % 2, function() {
      padding.push("");
    });
    return references.concat(padding);
  } else {
    return references;
  }
}
function factorInvoiceIdFromActiveDocuments(activeDocuments) {
  return _.chain(activeDocuments).pluck("factor_invoice_id").compact().first().value();
}
function overriddenFlags() {
  return Api.Account.overriddenAuditFlags();
}
function today() {
  return moment(/* @__PURE__ */ new Date()).format("YYYY-MM-DD");
}
function mapLocationData(source, addressComponents) {
  const locationData = {
    city: null,
    state: null,
    postal_code: null,
    street_name: null,
    country: null,
    source
  };
  addressComponents.map((component) => {
    switch (component.types[0]) {
      case "locality":
        locationData.city = component.long_name;
        break;
      case "administrative_area_level_1":
        locationData.state = component.short_name;
        break;
      case "country":
        locationData.country = component.short_name;
        break;
      case "postal_code":
        locationData.postal_code = component.long_name;
        break;
      case "route":
        locationData.street_name = component.short_name;
        break;
    }
  });
  return locationData;
}
function onEnterKeyRun(f) {
  return function(event) {
    if (event.key === "Enter" && !isImeKey(event.nativeEvent)) {
      f(event);
    }
  };
}
function showCarrierInvoiceNumber() {
  return Api.Account.currentSettings().factor_send_carrier_invoice_number_to_cadence;
}
function joinText() {
  return /* @__PURE__ */ jsx("div", { className: "load-detail__save-buttons-join-text", children: "or" });
}
function templateVariables() {
  return Api.Account.current().payables_template_variables;
}
function paymentsNetworkEnabled() {
  return Api.Account.currentSettings().payments_network_enabled;
}
function verificationsEnabled() {
  return Api.Account.currentSettings().verifications_enabled;
}
function verificationsWorkflowEnabled() {
  return Api.Account.currentSettings().verifications_workflow_enabled;
}
function debtorVerificationStatusComponent(debtorVerificationStatus) {
  if (!debtorVerificationStatus) {
    return null;
  }
  let notificationClassName = "";
  let iconSvg = null;
  switch (debtorVerificationStatus.status) {
    case "error":
      notificationClassName = "v3__notification v3__notification--inline v3__notification--error";
      iconSvg = /* @__PURE__ */ jsx(
        "svg",
        {
          className: "v3__icon",
          height: "16px",
          width: "16px",
          viewBox: "0 0 16 16",
          "aria-hidden": "true",
          children: /* @__PURE__ */ jsx("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.7301 4.4169C10.9564 4.4169 11.1734 4.50678 11.3334 4.66677C11.4136 4.74612 11.4773 4.8406 11.5208 4.94474C11.5642 5.04887 11.5866 5.16059 11.5866 5.27343C11.5866 5.38627 11.5642 5.498 11.5208 5.60213C11.4773 5.70626 11.4136 5.80074 11.3334 5.8801L9.20673 8.0001L11.3334 10.1268C11.4934 10.2868 11.5833 10.5038 11.5833 10.7301C11.5833 10.9564 11.4934 11.1734 11.3334 11.3334C11.1706 11.4907 10.9531 11.5785 10.7267 11.5785C10.5004 11.5785 10.2829 11.4907 10.1201 11.3334L8.00006 9.2001L5.88673 11.3334C5.72495 11.4952 5.50553 11.5861 5.27673 11.5861C5.04794 11.5861 4.82851 11.4952 4.66673 11.3334C4.50495 11.1717 4.41406 10.9522 4.41406 10.7234C4.41406 10.6101 4.43638 10.498 4.47973 10.3933C4.52308 10.2886 4.58663 10.1935 4.66673 10.1134L6.80007 8.0001L4.66673 5.8801C4.50794 5.71809 4.41899 5.50029 4.41899 5.27343C4.41899 5.04658 4.50794 4.82877 4.66673 4.66677C4.7462 4.58553 4.84109 4.52099 4.94584 4.47692C5.05059 4.43286 5.16309 4.41016 5.27673 4.41016C5.39037 4.41016 5.50287 4.43286 5.60762 4.47692C5.71237 4.52099 5.80726 4.58553 5.88673 4.66677L8.00006 6.79343L10.1267 4.66677C10.2868 4.50678 10.5038 4.4169 10.7301 4.4169Z",
              fill: "#FF6347"
            }
          ) })
        }
      );
      break;
    case "warning":
      notificationClassName = "v3__notification v3__notification--inline v3__notification--warning";
      iconSvg = /* @__PURE__ */ jsx(
        "svg",
        {
          className: "v3__icon",
          height: "16px",
          width: "16px",
          viewBox: "0 0 16 16",
          "aria-hidden": "true",
          children: /* @__PURE__ */ jsx("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M15.8471 13.9617L9.18279 0.744345C9.06983 0.519844 8.90023 0.331839 8.69233 0.20065C8.48443 0.0694619 8.24614 7.879e-05 8.0032 0C7.76027 7.879e-05 7.52197 0.0694619 7.31407 0.20065C7.10617 0.331839 6.93658 0.519844 6.82361 0.744345L0.15927 13.9617C0.0483055 14.1768 -0.00641988 14.4187 0.000599508 14.6629C0.00761889 14.9072 0.0761354 15.1452 0.199256 15.353C0.320703 15.5532 0.48913 15.7177 0.688569 15.8309C0.888007 15.9442 1.11184 16.0023 1.33886 15.9999H14.6675C14.897 15.9999 15.1225 15.938 15.3223 15.8203C15.5221 15.7026 15.6894 15.533 15.808 15.328C15.9266 15.1231 15.9925 14.8896 15.9994 14.6502C16.0063 14.4109 15.9538 14.1737 15.8471 13.9617ZM7.33677 5.56519C7.33677 5.38069 7.40698 5.20375 7.53196 5.07329C7.65694 4.94284 7.82645 4.86954 8.0032 4.86954C8.17995 4.86954 8.34946 4.94284 8.47444 5.07329C8.59942 5.20375 8.66964 5.38069 8.66964 5.56519V9.73909C8.66964 9.92358 8.59942 10.1005 8.47444 10.231C8.34946 10.3614 8.17995 10.4347 8.0032 10.4347C7.82645 10.4347 7.65694 10.3614 7.53196 10.231C7.40698 10.1005 7.33677 9.92358 7.33677 9.73909V5.56519ZM8.03652 13.5652C7.77404 13.5636 7.52225 13.4564 7.33356 13.2659C7.14488 13.0754 7.03383 12.8163 7.02354 12.5426C7.01909 12.405 7.04108 12.268 7.08823 12.1395C7.13539 12.011 7.20673 11.8937 7.29806 11.7944C7.38939 11.6952 7.49884 11.6161 7.61996 11.5618C7.74107 11.5075 7.87139 11.4791 8.0032 11.4782C8.26569 11.4798 8.51748 11.587 8.70616 11.7775C8.89485 11.9679 9.00589 12.227 9.01618 12.5008C9.02064 12.6383 8.99864 12.7754 8.95149 12.9039C8.90434 13.0324 8.83299 13.1497 8.74166 13.2489C8.65034 13.3481 8.54088 13.4273 8.41977 13.4816C8.29866 13.5359 8.16834 13.5643 8.03652 13.5652Z",
              fill: "#FFC229"
            }
          ) })
        }
      );
      break;
    case "success":
      notificationClassName = "v3__notification v3__notification--inline v3__notification--success";
      iconSvg = /* @__PURE__ */ jsx(
        "svg",
        {
          className: "v3__icon",
          height: "16px",
          width: "16px",
          viewBox: "0 0 16 16",
          "aria-hidden": "true",
          children: /* @__PURE__ */ jsx("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM12.62 5.46667L8.05334 11.66C8.0002 11.7324 7.93297 11.7933 7.8557 11.8391C7.77843 11.8849 7.6927 11.9146 7.60366 11.9265C7.51462 11.9383 7.42411 11.932 7.33756 11.908C7.25101 11.884 7.17021 11.8427 7.1 11.7867L3.84 9.18C3.77152 9.12498 3.71458 9.05698 3.67247 8.97989C3.63035 8.90279 3.60389 8.81814 3.59459 8.73079C3.5853 8.64344 3.59336 8.55511 3.61832 8.47088C3.64327 8.38666 3.68463 8.30819 3.74 8.24C3.85078 8.10557 4.00977 8.01984 4.18296 8.00115C4.35614 7.98247 4.52976 8.0323 4.66667 8.14L7.38667 10.3133L11.5467 4.66667C11.6516 4.5261 11.8078 4.43257 11.9813 4.40636C12.1547 4.38015 12.3315 4.42338 12.4733 4.52667C12.5453 4.57824 12.6064 4.64364 12.6528 4.71906C12.6993 4.79447 12.7302 4.87839 12.7439 4.9659C12.7575 5.05341 12.7536 5.14277 12.7323 5.22875C12.7111 5.31473 12.6729 5.39561 12.62 5.46667Z",
              fill: "#14994C"
            }
          ) })
        }
      );
      break;
    case "info":
      notificationClassName = "v3__notification v3__notification--inline v3__notification--info";
      iconSvg = /* @__PURE__ */ jsx(
        "svg",
        {
          className: "v3__icon",
          height: "16px",
          width: "16px",
          viewBox: "0 0 16 16",
          "aria-hidden": "true",
          children: /* @__PURE__ */ jsx("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0V0ZM8.16667 3.33333C8.36445 3.33333 8.55779 3.39198 8.72224 3.50186C8.88669 3.61174 9.01486 3.76792 9.09055 3.95065C9.16624 4.13338 9.18604 4.33444 9.14746 4.52842C9.10887 4.7224 9.01363 4.90059 8.87378 5.04044C8.73392 5.18029 8.55574 5.27553 8.36176 5.31412C8.16778 5.3527 7.96671 5.3329 7.78399 5.25721C7.60126 5.18153 7.44508 5.05335 7.3352 4.8889C7.22532 4.72445 7.16667 4.53111 7.16667 4.33333C7.16667 4.06812 7.27203 3.81376 7.45956 3.62623C7.6471 3.43869 7.90145 3.33333 8.16667 3.33333ZM9.66667 12.3333H7C6.82319 12.3333 6.65362 12.2631 6.5286 12.1381C6.40358 12.013 6.33334 11.8435 6.33334 11.6667C6.33334 11.4899 6.40358 11.3203 6.5286 11.1953C6.65362 11.0702 6.82319 11 7 11H7.5C7.54421 11 7.5866 10.9824 7.61786 10.9512C7.64911 10.9199 7.66667 10.8775 7.66667 10.8333V7.83333C7.66667 7.78913 7.64911 7.74674 7.61786 7.71548C7.5866 7.68423 7.54421 7.66667 7.5 7.66667H7C6.82319 7.66667 6.65362 7.59643 6.5286 7.4714C6.40358 7.34638 6.33334 7.17681 6.33334 7C6.33334 6.82319 6.40358 6.65362 6.5286 6.5286C6.65362 6.40357 6.82319 6.33333 7 6.33333H7.66667C8.02029 6.33333 8.35943 6.47381 8.60948 6.72386C8.85953 6.97391 9 7.31304 9 7.66667V10.8333C9 10.8775 9.01756 10.9199 9.04882 10.9512C9.08008 10.9824 9.12247 11 9.16667 11H9.66667C9.84348 11 10.0131 11.0702 10.1381 11.1953C10.2631 11.3203 10.3333 11.4899 10.3333 11.6667C10.3333 11.8435 10.2631 12.013 10.1381 12.1381C10.0131 12.2631 9.84348 12.3333 9.66667 12.3333Z",
              fill: "currentColor"
            }
          ) })
        }
      );
      break;
    default:
      return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "enable_shared-ui-v3", children: /* @__PURE__ */ jsx("div", { className: "v3__theme", children: /* @__PURE__ */ jsxs("div", { className: notificationClassName, children: [
    /* @__PURE__ */ jsx("span", { className: "v3__notification-icon", children: iconSvg }),
    /* @__PURE__ */ jsxs("div", { className: "v3__notification-text", children: [
      /* @__PURE__ */ jsx("div", { className: "v3__notification-text-title", children: debtorVerificationStatus.title }),
      debtorVerificationStatus.title.length + debtorVerificationStatus.description.length < 50 ? /* @__PURE__ */ jsx("span", { className: "v3__notification-text-message", children: debtorVerificationStatus.description }) : /* @__PURE__ */ jsx("div", { className: "v3__notification-text-message", children: debtorVerificationStatus.description })
    ] })
  ] }) }) });
}
function possibleDebtorNotes(debtor) {
  if (_.isEmpty(debtor == null ? void 0 : debtor.notes)) return null;
  return /* @__PURE__ */ jsxs("div", { children: [
    "Notes:",
    /* @__PURE__ */ jsx("div", { className: "factor-invoice__debtor-notes", children: /* @__PURE__ */ jsx("code", { children: debtor.notes }) })
  ] });
}
function possibleDebtorPhoneNumber(priOrSec, phoneNumber) {
  if (!_.isEmpty(phoneNumber)) {
    return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("a", { tabIndex: -1, href: "tel:" + phoneNumber, children: [
      priOrSec,
      ": ",
      phoneNumber.replaceAll(" ", "-"),
      " "
    ] }) });
  }
}
function possibleDebtorEmail(debtor) {
  const possibleEmail = getDebtorEmail(debtor);
  if (possibleEmail != null) return /* @__PURE__ */ jsxs("div", { children: [
    "Email: ",
    possibleEmail
  ] });
  return null;
}
function getDebtorEmail(debtor) {
  var _a, _b;
  return (_b = (_a = debtor.cadence_debtor_details.email) != null ? _a : debtor.billing_contact.email) != null ? _b : null;
}
function getRateConEmails(invoice) {
  return invoice.document_ids.map((id) => DocumentsService.getDocumentById(id)).filter((document) => document.type === "rateConfirmation").map((document) => {
    var _a;
    const brokerEmail = (_a = document.broker_email_addresses) != null ? _a : [];
    return Array.isArray(brokerEmail) ? brokerEmail : [brokerEmail];
  }).reduce((acc, val) => acc.concat(val), []).filter((email) => email.includes("@"));
}
function emailMatchesValidDomains(email, validDomains) {
  if (!email.includes("@")) return false;
  const emailParts = email.split("@");
  if (emailParts.length != 2) return false;
  const domain = emailParts[1].toLowerCase();
  const lowerCaseValidDomains = validDomains.map(
    (domain2) => domain2.toLowerCase()
  );
  return lowerCaseValidDomains.includes(domain);
}
function possibleDebtorNoBuy(debtor) {
  if (debtor.no_buy) {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("i", { className: "fi-alert alert" }),
      "\xA0No Buy"
    ] });
  }
}
function verificationVerdict(state) {
  switch (state) {
    case "success":
      return { label: "All Clear", severity: "clear", glyph: "fi-check" };
    case "delivery_in_progress":
      return {
        label: "Verified, Delivery Unconfirmed",
        severity: "clear",
        glyph: "fi-check"
      };
    case "fail":
      return { label: "Alert", severity: "alert", glyph: "fi-alert" };
    case "non_participating_carrier":
      return {
        label: "Carrier Not Participating",
        severity: "unverifiable",
        glyph: "fi-prohibited"
      };
    case "unverifiable_load":
      return {
        label: "Load Not Verifiable",
        severity: "unverifiable",
        glyph: "fi-prohibited"
      };
    case "pending":
      return { label: "Checking", severity: "checking", glyph: "fi-clock" };
    default:
      return { label: "", severity: "", glyph: "" };
  }
}
function unverifiedDetailView(message) {
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsx("i", { className: "fi-alert load-detail__debtor-verification-detail-unverified-icon" }),
    message
  ] });
}
function displayedOnFailureDetails(disclosureDetails) {
  var failedDetails = [];
  if (disclosureKeysInclude(disclosureDetails, "load_issue_failure")) {
    failedDetails = ["load_issue_failure"];
  } else if (disclosureKeysInclude(disclosureDetails, "on_demand_record_failure")) {
    failedDetails = ["on_demand_record_failure"];
  }
  if (disclosureKeysInclude(disclosureDetails, "possible_fees_failure")) {
    failedDetails = failedDetails.concat("possible_fees_failure");
  }
  return failedDetails;
}
function verificationDetailAlternateDisplayFailureMessage(type, details) {
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsx("i", { className: "fi-x load-detail__debtor-verification-detail-icon fail" }),
    "\xA0",
    verificationFailureText(type, details)
  ] });
}
function verificationDetailSkippedMessage(type) {
  var message = "";
  switch (type) {
    case "undelivered_failue":
      message = "Load delivery unconfirmed";
      break;
  }
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsx("i", { className: "fi-minus load-detail__debtor-verification-detail-icon skipped" }),
    "\xA0",
    message
  ] });
}
function verificationDetailFailureMessage(type, details) {
  return /* @__PURE__ */ jsx("div", { children: verificationFailureText(type, details) });
}
function verificationFailureText(type, details) {
  switch (type) {
    case "load_not_found_failure":
      return "Load not found";
    case "undelivered_failue":
      return "Load not delivered";
    case "carrier_mismatch_failure":
      return Account.carrierTerm() + " does not match";
    case "load_issue_failure":
    case "on_demand_record_failure":
      return "Load has an issue";
    case "possible_fees_failure":
      return "Load may have fees";
    case "remit_to_failure":
      return "Remit-to address does not match";
    case "amount_mismatch_failure":
      return details.broker_amount ? "Amount does not match the broker's $" + generalFormatter.cleanAmount(details.broker_amount) : "Amount does not match";
  }
}
function disclosureKeysInclude(disclosure, keyToCheck) {
  return disclosureKeys(disclosure).includes(keyToCheck);
}
function disclosureKeys(disclosure) {
  const keys = Object.keys(disclosure);
  if (keys.includes("load_issue_failure") && keys.includes("amount_mismatch_failure")) {
    return _.without(keys, "amount_mismatch_failure");
  } else {
    return keys;
  }
}
function searchSectionHeader() {
  return /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: "Possible Matches" });
}
function noResultsFound() {
  return /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
    searchSectionHeader(),
    /* @__PURE__ */ jsx("div", { className: "row", children: "No invoices match your criteria." })
  ] });
}
function searchResultsHeader() {
  return /* @__PURE__ */ jsxs("div", { className: "row factor-invoice__search-headers-row", children: [
    /* @__PURE__ */ jsx("div", { className: "small-1 column", children: "\xA0" }),
    /* @__PURE__ */ jsx("div", { className: "small-3 column factor-invoice__search-header", children: "SENDER INFORMATION" }),
    /* @__PURE__ */ jsx("div", { className: "small-3 column factor-invoice__search-header", children: "INVOICE INFORMATION" }),
    /* @__PURE__ */ jsx("div", { className: "small-3 column factor-invoice__search-header", children: "DOCUMENTS" })
  ] });
}
function modelForSearch(documentBatches, invoiceId) {
  return new GroupedDocumentBrowserModel(
    DocumentBatchGroupCreator(documentBatches, function(doc) {
      return doc.factor_invoice_id === invoiceId;
    }),
    function() {
      return false;
    },
    null
  );
}
function invoiceInformation(result) {
  var factorInvoice2 = result.factor_invoice;
  var fields = {
    "Origin:": "origin",
    "Destination:": "destination",
    "Amount: ": "source_invoice_amount",
    "Debtor: ": "debtor",
    "Reference Match:": "references",
    "Load ID:": "load_id"
  };
  var divs = _.mapObject(fields, function(val, key) {
    if (val === "load_id" && factorInvoice2.load_id) {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("strong", { children: [
          " ",
          key,
          " "
        ] }),
        " ",
        factorInvoice2.load_id
      ] }, "factor-invoice__" + factorInvoice2.id + val);
    } else if (val === "debtor" && result.debtor) {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("strong", { children: [
          " ",
          key,
          " "
        ] }),
        " ",
        result.debtor.name
      ] }, "factor-invoice__" + factorInvoice2.id + val);
    } else if (val === "references") {
      var references = _.without(result.matches, "origin", "destination");
      return _.map(references, _.partial(referenceDiv, key));
    } else {
      var shouldBeCalledOut = _.contains(result.matches, val);
      var classes = classNames({
        "factor-invoice__matching-search-field": shouldBeCalledOut
      });
      if (factorInvoice2[val]) {
        const value = invoiceFieldValue(factorInvoice2, val);
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: classes,
            children: [
              " ",
              /* @__PURE__ */ jsxs("strong", { children: [
                " ",
                key,
                " "
              ] }),
              " ",
              value,
              " "
            ]
          },
          "factor-invoice__" + factorInvoice2.id + val
        );
      }
    }
  });
  return _.values(divs);
}
function invoiceFieldValue(factorInvoice2, value) {
  if (value === "source_invoice_amount") {
    return generalFormatter.currency(factorInvoice2[value]);
  } else {
    return factorInvoice2[value];
  }
}
function referenceDiv(label, reference) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "factor-invoice__matching-search-field",
      children: [
        " ",
        /* @__PURE__ */ jsxs("strong", { children: [
          " ",
          label,
          " "
        ] }),
        " ",
        reference,
        " "
      ]
    },
    "factor-invoice__" + reference
  );
}
function invoiceEmailSubject(factorInvoice2) {
  return factorInvoice2.document_batch_email_subject || "No Subject";
}
function invoiceEmailDate(factorInvoice2) {
  const emailDate = factorInvoice2.document_batch_email_date;
  if (!emailDate) return "";
  return generalFormatter.superShortDate(emailDate) + " " + generalFormatter.superShortTime(emailDate);
}
function documentTypesForInvoice(invoice) {
  return _.chain(invoice.document_ids).map((id) => DocumentsService.getDocumentById(id)).map((document) => {
    if (_.contains(
      ["invoice", "rateConfirmation", "billOfLading"],
      document.type
    )) {
      return title(document);
    } else {
      return "Other";
    }
  }).groupBy(_.identity).pairs().map(([t, ts]) => `${t} (${ts.length})`).value();
}
function asPairs(a) {
  var tmp = a.slice();
  var pairs = [];
  while (!_.isEmpty(tmp)) {
    pairs.push(tmp.splice(0, 2));
  }
  return pairs;
}
function currentGroupID(props, groupProps) {
  if ((groupProps || props).groupID) {
    return (groupProps || props).groupID;
  }
  return "nogroup";
}
function initialStateForGroup(props) {
  const continueWithoutInvoiceInformation = props.continueWithoutInvoiceInformation;
  return {
    matchingInvoices: continueWithoutInvoiceInformation,
    viewDocuments: false,
    source_invoice_amount: null,
    debtor: null,
    load_id: null,
    source_invoice_number: null,
    lock_version: 0,
    source_invoice_date: null,
    notes: null,
    funding_notes: null,
    carrier_notes: null,
    origin: null,
    origin_lat: null,
    origin_lng: null,
    destination: null,
    destination_lat: null,
    destination_lng: null,
    extracted_fields: {},
    search_only_with_ratecon: false,
    pendingTimeout: false,
    sendingException: false,
    savingException: false,
    savingInvoice: false,
    rejecting: false,
    loadingInvoice: true,
    searchingInvoices: false,
    loadingSearchResults: false,
    abandoningInvoice: false,
    mergedFactorInvoiceIds: [],
    fetched: false,
    showingVerificationDetails: false,
    shouldShowBasicInvoiceInformation: true,
    references: ["", ""],
    carrier_amount: null,
    editedFields: {}
  };
}
function getInvoiceIdsFromBatches(props) {
  const invoiceIds = [];
  props.documentBatches.forEach((documentBatch) => {
    documentBatch.factor_invoices.forEach((invoice) => {
      if (invoiceIds.indexOf(invoice.id) === -1) {
        invoiceIds.push(invoice.id);
      }
    });
  });
  return invoiceIds;
}
function transportationClient(state) {
  const carrier = state.carrier;
  return carrier && carrier.transportation_client;
}
function carrierId(state) {
  var carrier = state.carrier;
  return carrier && carrier.id;
}
function onLastIncompleteGroup(props) {
  return props && props.model && props.model.incompleteGroups().length <= 1;
}
function embedReturnUrl(props) {
  return props.onDone || null;
}
function completionContext(props) {
  if (props.hasMore) {
    return "and continue to the next Group";
  } else {
    return "and return to the Dashboard";
  }
}
function documentBatchIds(props) {
  return _.pluck(props.documentBatches, "id");
}
function findEmail(props, documentBatches) {
  var emailID = props.location.query["emailMessageId"];
  if (emailID) {
    return _.findWhere(_.pluck(documentBatches, "email_message"), {
      id: parseInt(emailID)
    });
  }
  return _.first(_.compact(_.pluck(documentBatches, "email_message")));
}
function stateForGroup(props, state, groupProps) {
  return state.groups[currentGroupID(props, groupProps)] || initialStateForGroup(props);
}
function invoiceUpdated(props, state, invoice) {
  return invoice.updated_at != stateForGroup(props, state).updated_at;
}
function invoiceExceptionEventsUpdated(props, state, invoice) {
  return invoice.exception_events !== stateForGroup(props, state).exception_events;
}
function clearTimer(props, state) {
  if (stateForGroup(props, state).pendingTimeout) {
    window.clearTimeout(stateForGroup(props, state).pendingTimeout);
  }
}
function isSaving(props, state) {
  return stateForGroup(props, state).savingInvoice;
}
function possibleDebtorWarning(props, state) {
  const debtor = stateForGroup(props, state).factorBroker;
  if (debtor && !_.isEmpty(debtor.warning)) {
    return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsxs("div", { className: "factor-invoice__debtor-warning", children: [
      /* @__PURE__ */ jsx("i", { className: "fi-alert alert" }),
      /* @__PURE__ */ jsx("div", { className: "debtor-name", children: debtor.name }),
      /* @__PURE__ */ jsx("div", { className: "debtor-warning", children: debtor.warning })
    ] }) }) });
  }
}
function fieldWithHint(props, state, input, field) {
  const submission = stateForGroup(props, state).factorClientInvoiceSubmission;
  const hint = submission && submission[field];
  if (!hint) {
    return input;
  }
  return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__field-with-hint", children: [
    input,
    /* @__PURE__ */ jsxs("div", { className: "factor-invoice__field-with-hint__hint", children: [
      "Submitted Value: ",
      hint
    ] })
  ] });
}
function shouldShowBasicInvoiceInformation(props, state) {
  return stateForGroup(props, state).shouldShowBasicInvoiceInformation;
}
function possibleVerificationDataSourceTooltip(props, state, verification) {
  var _a;
  const verificationType = (_a = stateForGroup(props, state).factorBroker) == null ? void 0 : _a.verifications_type;
  if (verificationType && (verificationType == "HubtranCustomer" || verificationType == "HubtranMultiAccountCustomer")) {
    return /* @__PURE__ */ jsx("a", { children: /* @__PURE__ */ jsx("i", { className: "fi-info", title: "Data provided by the debtor's TMS." }) });
  }
}
function possibleVerificationDetails(props, state, disclosure) {
  if (isShowingVerificationDetails(props, state) && disclosure) {
    return /* @__PURE__ */ jsx("div", { className: "load-detail__document-information", children: /* @__PURE__ */ jsx("div", { className: "column", children: disclosureKeys(disclosure).map(
      (type) => verificationDetailFailureMessage(type, disclosure[type])
    ) }) });
  }
}
function isMatchingInvoices(props, state) {
  return stateForGroup(props, state).matchingInvoices;
}
function isMatchingInvoicesOnExtract(props, state) {
  return stateForGroup(props, state).matchingInvoicesOnExtract;
}
function isShowingVerificationDetails(props, state) {
  return stateForGroup(props, state).showingVerificationDetails;
}
function extractedFieldsFields(props, state) {
  const settings = Api.Account.currentSettings() || {};
  if (stateForGroup(props, state).factorBroker) {
    const fieldsFromCustomer = stateForGroup(props, state).factorBroker.settings.factor_invoice_extracted_fields || [];
    const fieldsFromAccount = settings.factor_invoice_extracted_fields || [];
    return _.uniq(
      _.reject(
        fieldsFromAccount.concat(fieldsFromCustomer),
        (field) => field.hidden
      )
    );
  } else {
    return settings.factor_invoice_extracted_fields || [];
  }
}
function factorInvoiceData(props, state) {
  var data = _.chain([
    "load_id",
    "source_invoice_amount",
    "source_invoice_number",
    "source_invoice_date",
    "notes",
    "origin",
    "origin_lat",
    "origin_lng",
    "destination",
    "destination_lat",
    "destination_lng",
    "tonu",
    "must_verify",
    "extracted_fields",
    "lock_version",
    "fuel_advance",
    "carrier_invoice_number",
    "carrier_amount",
    "payments_network_external_load_id",
    "brokered_carrier_term_id",
    "load_id_pattern_mismatch"
  ]).reduce((o, k) => {
    o[k] = stateForGroup(props, state)[k];
    return o;
  }, {}).value();
  data.factor_broker_id = stateForGroup(props, state).factorBroker ? stateForGroup(props, state).factorBroker.id : null;
  const brokeredCarrierId = stateForGroup(props, state).brokeredCarrier ? stateForGroup(props, state).brokeredCarrier.id : null;
  data.brokered_carrier_id = brokeredCarrierId;
  data.carrier_id = carrierId(state);
  data.id = factorInvoice(props, state) ? factorInvoice(props, state).id : null;
  data.source_invoice_amount = generalFormatter.cleanAmount(
    data.source_invoice_amount
  );
  data.carrier_amount = generalFormatter.cleanAmount(data.carrier_amount);
  data.references = (stateForGroup(props, state).references || ["", ""]).slice(
    0
  );
  stripPaddingFromReferences(data.references);
  return data;
}
function showSaveAndApproveAll(props, state) {
  return !Api.Account.currentSettings().verifications_workflow_enabled && isSaveable(props, state) && Auth._currentUser.approver && isApprovable(props, state) && onLastIncompleteGroup(props);
}
function isApprovable(props, state) {
  return factorInvoice(props, state) && loadHelper.isApprovable(factorInvoice(props, state));
}
function isSaveable(props, state) {
  return !stateForGroup(props, state).sendingException && !readOnly(factorInvoice(props, state)) && !shouldShowBasicInvoiceInformation(props, state);
}
function factorInvoice(props, state) {
  return stateForGroup(props, state).factorInvoice;
}
function possibleCompletionContext(props, state) {
  if (isSaveable(props, state)) {
    return completionContext(props);
  }
}
function debtorDetails(props, state) {
  const debtor = stateForGroup(props, state).factorBroker;
  if (debtor) {
    return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__compact-address", children: [
      /* @__PURE__ */ jsx(Address, { source: debtor.payment_address, compact: true }),
      possibleDebtorEmail(debtor),
      possibleEmailMismatch(props, state, debtor),
      possibleDebtorNoBuy(debtor),
      possibleDebtorPhoneNumber("Primary", debtor.external_data.Phone1),
      possibleDebtorPhoneNumber("Secondary", debtor.external_data.Phone2),
      possibleDebtorNotes(debtor)
    ] });
  }
}
function possibleEmailMismatch(props, state, debtor) {
  if (!isRateConEmailInvalid(props, state, debtor)) return null;
  return /* @__PURE__ */ jsxs("div", { className: "alert", children: [
    /* @__PURE__ */ jsx("i", { className: "fi-x-circle" }),
    "\xA0Email on rate con does not match"
  ] });
}
function isRateConEmailInvalid(props, state, debtor) {
  const debtorEmail = getDebtorEmail(debtor);
  const validDomains = debtor.email_domains_to_validate || [];
  const rateConEmails = getRateConEmails(factorInvoice(props, state));
  if (rateConEmails.length === 0 || validDomains.length === 0) return false;
  return !rateConEmails.some(
    (email) => emailMatchesValidDomains(email, validDomains) || email === debtorEmail
  );
}
function requiredReferenceType(props, state, defaultInvoice) {
  const invoice = defaultInvoice || factorInvoice(props, state);
  return invoice && invoice.primary_reference_type || "load_id";
}
function requiredReferenceTypeName(props, state) {
  if (requiredReferenceType(props, state) == "source_invoice_number") {
    return "Invoice Number";
  } else {
    return "Load ID";
  }
}
function needsBasicInvoiceInformation(props, state, groupState) {
  const refType = requiredReferenceType(props, state, groupState.factorInvoice);
  return !groupState.factorBroker || s.isBlank(groupState[refType]);
}
function currentGroupNeedsBasicInvoiceInformation(props, state) {
  return needsBasicInvoiceInformation(
    props,
    state,
    stateForGroup(props, state)
  );
}
function brokeredCarrierDetails(props, state) {
  const brokeredCarrier = factorInvoice(props, state) && factorInvoice(props, state).brokered_carrier;
  if (brokeredCarrier) {
    return /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
      /* @__PURE__ */ jsx("label", { children: "Carrier Details" }),
      /* @__PURE__ */ jsx("div", { className: "factor-invoice__compact-address", children: /* @__PURE__ */ jsx(
        Address,
        {
          source: brokeredCarrier.tms_payment_address,
          compact: true
        }
      ) })
    ] });
  } else {
    return null;
  }
}
function alternateVerificationDetails(props, state, verification) {
  if (isShowingVerificationDetails(props, state)) {
    const defaultDisplayedDetails = [
      "load_not_found_failure",
      "undelivered_failue",
      "carrier_mismatch_failure",
      "remit_to_failure",
      "amount_mismatch_failure"
    ];
    var detailContent = /* @__PURE__ */ jsx("div", {});
    switch (verification.state) {
      case "success":
        detailContent = defaultDisplayedDetails.map(
          (detail) => verificationDetailSuccessMessage(props, state, detail)
        );
        break;
      case "delivery_in_progress":
        detailContent = defaultDisplayedDetails.map(
          (detail) => detail === "undelivered_failue" ? verificationDetailSkippedMessage(detail) : verificationDetailSuccessMessage(props, state, detail)
        );
        break;
      case "fail":
        detailContent = displayFailedState(
          props,
          state,
          defaultDisplayedDetails,
          verification.disclosure_details,
          verification.mode
        );
        break;
      case "non_participating_carrier":
        detailContent = unverifiedDetailView(
          "Nonparticipating or unmatched carrier. This may be due to a missing MC# in your FMS"
        );
        break;
      case "unverifiable_load":
        detailContent = unverifiedDetailView("Load Not Verifiable");
        break;
      case "pending":
        detailContent = unverifiedDetailView("Loading");
        break;
    }
    return /* @__PURE__ */ jsx("ul", { className: "load-detail__debtor-verification-detail-display", children: detailContent });
  }
}
function displayFailedState(props, state, defaultDisplayedDetails, disclosureDetails, mode) {
  if (disclosureKeysInclude(disclosureDetails, "load_not_found_failure")) {
    return verificationDetailAlternateDisplayFailureMessage(
      "load_not_found_failure",
      disclosureDetails["load_not_found_failure"]
    );
  } else {
    return defaultDisplayedDetails.concat(displayedOnFailureDetails(disclosureDetails)).map(
      (detail) => displayMaybeFailedDetail(props, state, detail, disclosureDetails, mode)
    );
  }
}
function displayMaybeFailedDetail(props, state, detailType, disclosureDetails, mode) {
  if (disclosureKeysInclude(disclosureDetails, detailType)) {
    return verificationDetailAlternateDisplayFailureMessage(
      detailType,
      disclosureDetails[detailType]
    );
  } else if (mode !== "restricted") {
    return verificationDetailSuccessMessage(props, state, detailType);
  }
}
function verificationDetailSuccessMessage(props, state, type) {
  var message = "";
  const loadId = factorInvoice(props, state).load_id;
  switch (type) {
    case "load_not_found_failure":
      message = loadId ? "Load #" + loadId + " found" : "Load found";
      break;
    case "undelivered_failue":
      message = "Load delivered";
      break;
    case "carrier_mismatch_failure":
      message = Account.carrierTerm() + " matches";
      break;
    case "load_issue_failure":
      message = "Load has no issues";
      break;
    case "possible_fees_failure":
      message = "Load has no fees";
      break;
    case "remit_to_failure":
      message = "Remit-to address matches";
      break;
    case "amount_mismatch_failure":
      message = "Amount matches";
      break;
  }
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsx("i", { className: "fi-check load-detail__debtor-verification-detail-icon success" }),
    "\xA0",
    message
  ] });
}
function possiblePaymentsNetworkLoad(props, state) {
  if (paymentsNetworkEnabled() && factorInvoiceData(props, state).payments_network_external_load_id) {
    return /* @__PURE__ */ jsx("div", { className: "row collapse", children: /* @__PURE__ */ jsxs("h3", { className: "load-detail__section-header", children: [
      "TPay Network Load Id:",
      " ",
      factorInvoiceData(props, state).payments_network_external_load_id
    ] }) });
  }
}
function approvedInvoiceReplyEmail(props, state) {
  if (!approvedFactorInvoice(props, state)) {
    return null;
  }
  return _.find(
    factorInvoice(props, state).email_messages,
    (email) => !email.completed_at && email.message_type === "reply" && email.id == props.location.query.emailId
  );
}
function approvedFactorInvoice(props, state) {
  const approvedStates = ["approved", "verified", "purchased"];
  const invoice = factorInvoice(props, state);
  return invoice && _.contains(approvedStates, invoice.state);
}
function abandonedFactorInvoice(props, state) {
  return factorInvoice(props, state) && factorInvoice(props, state).state === "abandoned";
}
function possibleOtherInvoices(props, state) {
  if (shouldShowBasicInvoiceInformation(props, state)) return;
  var invoices = stateForGroup(props, state).allInvoices;
  if (!_.isEmpty(invoices) && invoices.length > 1) {
    return /* @__PURE__ */ jsx(
      PreviousInvoiceInformation,
      {
        factorInvoices: invoices,
        currentInvoice: factorInvoice(props, state),
        location: props.location
      }
    );
  }
}
function exceptionEvents(props, state) {
  if (factorInvoice(props, state)) {
    return factorInvoice(props, state).exception_events;
  } else {
    return [];
  }
}
function buildSearchParams(props, state, invoiceId) {
  const factorInvoiceId = invoiceId || factorInvoice(props, state) && factorInvoice(props, state).id;
  return {
    carrier_id: carrierId(state),
    id: factorInvoiceId,
    distance: 25
  };
}
function isHubtranInvoice(props, state) {
  return factorInvoice(props, state) && factorInvoice(props, state).source_system === "hubtran";
}
function canReject(props, state) {
  return factorInvoice(props, state) && factorInvoice(props, state).state == "processed";
}
function isProcessedInWaiting(props, state) {
  return readOnly(factorInvoice(props, state)) && factorInvoice(props, state) && factorInvoice(props, state).active_exceptioned_item;
}
function canAbandonInvoice(props, state) {
  return !approvedFactorInvoice(props, state) && !abandonedFactorInvoice(props, state);
}
function possibleLoadIdMismatch(props, state) {
  const { verification } = stateForGroup(props, state);
  if (factorInvoiceData(props, state).load_id_pattern_mismatch && (!verification || verification.state === "unverifiable_load")) {
    return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx("div", { className: "factor-invoice__load-id-pattern-mismatch-warning", children: /* @__PURE__ */ jsxs("div", { className: "fi-alert alert", children: [
      " ",
      "Load ID does not match debtor load pattern"
    ] }) }) }) });
  }
}
function possibleSourceSystemWarning(props, state) {
  if (factorInvoice(props, state) && !isHubtranInvoice(props, state)) {
    return /* @__PURE__ */ jsx("div", { className: "factor-invoice__invoice-help-text", children: "This invoice was created externally and was not processed in TriumphPay Audit." });
  }
}
function possibleReviewLink(props, state) {
  if (!readOnly(factorInvoice(props, state))) {
    return /* @__PURE__ */ jsx("a", { onClick: (event) => handleReviewFlagClick(props, state, event), children: "review flags" });
  }
}
function handleReviewFlagClick(props, state, event) {
  event.preventDefault();
  event.stopPropagation();
  if (props.onReviewAuditFlags) {
    props.onReviewAuditFlags(
      factorInvoice(props, state),
      stateForGroup(props, state).auditFlags,
      factorInvoice(props, state).document_ids
    );
  }
}
function possibleRulesAndExceptions(props, state, invoice) {
  if (!shouldShowBasicInvoiceInformation(props, state)) {
    return /* @__PURE__ */ jsx(
      RulesAndExceptions,
      {
        readOnly: readOnly(factorInvoice(props, state)),
        factorInvoice: invoice,
        exceptionCreator: (message) => createException(props, state, message),
        exceptionResolver: (message, exception) => resolveException(props, state, message, exception),
        exceptionEvents: exceptionEvents(props, state)
      }
    );
  }
}
function createException(props, state, message) {
  return Api.ExceptionEvents.create(
    factorInvoice(props, state).id,
    "factor",
    message
  );
}
function resolveException(props, state, message, exception) {
  return Api.ExceptionEvents.resolve(
    factorInvoice(props, state).id,
    "factor",
    message,
    exception
  );
}
function removeComplete(props) {
  ToDashboardWithFilters(props.location, embedReturnUrl(props));
}
function possibleIgnoreProcessedMessage(props, state) {
  if (isProcessedInWaiting(props, state)) {
    return /* @__PURE__ */ jsx(
      RemoveFromWaiting,
      {
        itemId: factorInvoice(props, state).active_exceptioned_item.id,
        onComplete: () => removeComplete(props)
      }
    );
  }
}
class FactorInvoice extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      groups: {},
      pusher: createPusherInstance(),
      processedInvoicesCount: 0
    });
    __publicField(this, "mounted", false);
    __publicField(this, "setStateForGroup", (values, props, callback) => {
      var newState = this.state;
      var currentState = newState.groups[currentGroupID(this.props, props)] || initialStateForGroup(this.props);
      newState.groups[currentGroupID(this.props, props)] = currentState;
      _.extend(currentState, values);
      this.setState(newState, callback);
    });
    __publicField(this, "updateProcessedInvoicesCount", (previousState) => {
      const factorInvoiceIds = getInvoiceIdsFromBatches(this.props);
      if (factorInvoiceIds.length === 0) {
        return;
      }
      Promise.all(
        _.map(factorInvoiceIds, (id) => {
          return FactorInvoicesService.getWithId(id);
        })
      ).then((invoices) => {
        const processed = invoices.filter((invoice) => {
          return invoice.state === "processed";
        });
        if (previousState.processedInvoicesCount !== processed.length) {
          this.setState({ processedInvoicesCount: processed.length });
        }
      });
    });
    __publicField(this, "invoiceCreated", (event, data) => {
      var _a;
      if (_.isEqual(
        _.pluck((_a = this.props.activeDocuments) != null ? _a : [], "id"),
        data.factor_invoice.document_ids
      )) {
        this.loadDataForCurrentGroup(
          this.props,
          this.state.pusher,
          data.factor_invoice,
          data.factor_invoices,
          data.verification
        );
      }
    });
    __publicField(this, "updateFromRemote", (data, props, updateRequestedAt, updateNeedsBasicInvoiceInformation = false) => {
      const currentState = stateForGroup(this.props, this.state, props);
      const edited = currentState.editedFields;
      const now = (/* @__PURE__ */ new Date()).getTime();
      const mergedInvoiceData = mergeInvoiceState(
        {
          factorInvoice: currentState.factorInvoice,
          lastDocumentSaveTime: this.props.lastDocumentSaveTime
        },
        data,
        updateRequestedAt
      );
      var newState = {
        factorInvoice: mergedInvoiceData.factorInvoice,
        factorBroker: data.factor_broker,
        brokeredCarrier: data.factor_invoice.brokered_carrier,
        verification: data.verification,
        verificationLastUpdatedAt: now,
        debtorVerificationStatus: data.debtor_verification_status,
        allInvoices: data.factor_invoices || currentState.factor_invoices,
        fetched: true,
        auditFlags: data.factor_invoice.data.auditFlags,
        destinationData: data.factor_invoice.data.destination,
        originData: data.factor_invoice.data.origin,
        loadingInvoice: false,
        factorClientInvoiceSubmission: data.factor_client_invoice_submission || currentState.factorClientInvoiceSubmission
      };
      if (currentState.nextSave) {
        const props2 = this.props;
        const params = currentState.nextSave.params;
        newState.auditFlags = params.audit_flags;
        const thisSaveRequestedAt = currentState.nextSave.requestedAt;
        if (updateRequestedAt != 0) {
          newState.nextSave = void 0;
          params.factor_invoice.lock_version = data.factor_invoice.lock_version;
          if (props2.documentBatchContext) {
            params.document_batch_id = props2.documentBatchContext.id;
            params.document_group_ids = _.map(
              props2.model.allGroups,
              (group) => group.id
            );
            params.incomplete_document_group_ids = _.map(
              props2.model.incompleteGroups(),
              (group) => group.id
            );
          }
          Api.FactorInvoices.create(params).then((data2) => {
            return this.updateFromRemote(data2, props2, thisSaveRequestedAt);
          });
        }
      } else {
        newState.savingInvoice = false;
        if (newState.verification && newState.verification.state == "pending") {
          setTimeout(() => {
            this.attemptToUpdateVerification();
          }, 1e3);
        }
      }
      _.extend(newState, data.factor_invoice);
      newState = _.omit(newState, (value, key) => {
        return edited[key] && edited[key] > updateRequestedAt;
      });
      const mergedState = _.extend({}, currentState, newState);
      if (!currentState.fetched || updateNeedsBasicInvoiceInformation) {
        newState.shouldShowBasicInvoiceInformation = needsBasicInvoiceInformation(
          this.props,
          this.state,
          newState
        );
      }
      if (needsBasicInvoiceInformation(this.props, this.state, mergedState)) {
        newState.shouldShowBasicInvoiceInformation = true;
      }
      if (newState.source_invoice_amount) {
        newState.source_invoice_amount = generalFormatter.cleanAmount(
          newState.source_invoice_amount
        );
      }
      if (newState.carrier_amount) {
        newState.carrier_amount = generalFormatter.cleanAmount(
          newState.carrier_amount
        );
      }
      if (newState.references) {
        newState.references = ensureReferencesHaveCorrectPadding(
          newState.references
        );
      }
      if (this.props.continueWithoutInvoiceInformation) {
        newState.matchingInvoices = true;
      }
      if (!needsBasicInvoiceInformation(this.props, this.state, newState)) {
        newState.matchingInvoices = false;
      }
      const lastUpdateAt = stateForGroup(this.props, this.state).factorInvoice && stateForGroup(this.props, this.state).factorInvoice.updated_at;
      this.setStateForGroup(newState, props || this.state.props);
      if (lastUpdateAt && lastUpdateAt != newState.factorInvoice.updated_at) {
        this.searchInvoices(data.factor_invoice.id);
      }
      return data.factor_invoice;
    });
    __publicField(this, "attemptToUpdateVerification", () => {
      if (stateForGroup(this.props, this.state).verification && stateForGroup(this.props, this.state).verification.state != "pending") {
        return;
      } else {
        const now = (/* @__PURE__ */ new Date()).getTime();
        const lastUpdatedAt = stateForGroup(this.props, this.state).verificationLastUpdatedAt || now;
        const oneSecond = 1e3;
        if (now - lastUpdatedAt < oneSecond) {
          return;
        } else {
          if (stateForGroup(this.props, this.state).factorInvoice && stateForGroup(this.props, this.state).factorInvoice.id) {
            Api.Verifications.verification({
              factorInvoiceId: stateForGroup(this.props, this.state).factorInvoice.id,
              timestamp: stateForGroup(this.props, this.state).verificationLastUpdatedAt || now
            }).then((data) => {
              if (data.verification && data.verification.state == "pending") {
                setTimeout(() => {
                  this.attemptToUpdateVerification();
                }, 1e3);
              } else {
                if (stateForGroup(this.props, this.state).factorInvoice && stateForGroup(this.props, this.state).factorInvoice.id == data.factor_invoice_id && stateForGroup(this.props, this.state).verificationLastUpdatedAt == data.timestamp) {
                  const newState = stateForGroup(this.props, this.state);
                  newState.verification = data.verification;
                  newState.verificationLastUpdatedAt = (/* @__PURE__ */ new Date()).getTime();
                  this.setStateForGroup(newState);
                } else {
                  setTimeout(() => {
                    this.attemptToUpdateVerification();
                  }, 1e3);
                }
              }
            }).catch(() => {
              setTimeout(() => {
                this.attemptToUpdateVerification();
              }, 1e3);
            });
          } else {
          }
        }
      }
    });
    __publicField(this, "grabInvoiceFromApi", (invoiceId, props, updateNeedsBasicInvoiceInformation = false) => {
      return FactorInvoicesService.fetchInvoiceAndRelated(invoiceId).then(
        ({
          factorInvoice: factorInvoice2,
          factorInvoices,
          verification,
          debtorVerificationStatus,
          factorClientInvoiceSubmission
        }) => {
          this.fetchDebtorAndUpdate(
            factorInvoice2.factor_broker_id,
            factorInvoice2,
            factorInvoices,
            verification,
            debtorVerificationStatus,
            props,
            updateNeedsBasicInvoiceInformation,
            factorClientInvoiceSubmission
          );
          return null;
        }
      );
    });
    __publicField(this, "loadDataForCurrentGroup", (props, pusher, factorInvoice2, factorInvoices, verification, debtorVerificationStatus) => {
      const invoiceId = props.factorInvoiceId || factorInvoiceIdFromActiveDocuments(props.activeDocuments);
      if (!invoiceId) {
        return null;
      } else {
        if (factorInvoice2 && factorInvoices && verification && debtorVerificationStatus) {
          this.fetchDebtorAndUpdate(
            factorInvoice2.factor_broker_id,
            factorInvoice2,
            factorInvoices,
            verification,
            debtorVerificationStatus,
            props
          );
        } else {
          this.grabInvoiceFromApi(invoiceId, props);
        }
        this.searchInvoices(invoiceId);
      }
      this.startListeningForGeocodeUpdates(props);
      return null;
    });
    __publicField(this, "fetchDebtorAndUpdate", (factorBrokerId, factorInvoice2, factorInvoices, verification, debtorVerificationStatus, props, updateNeedsBasicInvoiceInformation, factorClientInvoiceSubmission) => {
      FactorBrokersService.getWithId(factorBrokerId).then((factorBroker) => {
        this.updateFromRemote(
          {
            factor_invoice: factorInvoice2,
            factor_broker: factorBroker,
            factor_invoices: factorInvoices,
            verification,
            debtor_verification_status: debtorVerificationStatus,
            factor_client_invoice_submission: factorClientInvoiceSubmission
          },
          props,
          (/* @__PURE__ */ new Date()).getTime(),
          updateNeedsBasicInvoiceInformation
        );
      }, _.identity);
    });
    __publicField(this, "startListeningForGeocodeUpdates", (props) => {
      const email = findEmail(this.props, props.documentBatches);
      this.setStateForGroup({ email }, props);
      if (email) {
        FactorInvoiceUpdateService.listenForGeocodeUpdates(
          this.state.pusher,
          email.id
        );
      }
    });
    __publicField(this, "fetchBrokeredCarrierTerms", () => {
      if (this.state.carrier && this.state.carrier.broker_client) {
        return BrokeredCarrierTermsService.forClient(this.state.carrier).then(
          (brokeredCarrierTerms) => {
            this.setState({ brokeredCarrierTerms });
          }
        );
      }
    });
    __publicField(this, "invoiceStoreUpdated", () => {
      if (this.mounted && factorInvoice(this.props, this.state) && factorInvoice(this.props, this.state).id) {
        const updatedInvoice = FactorInvoicesStore.find(
          factorInvoice(this.props, this.state).id
        );
        if (invoiceUpdated(this.props, this.state, updatedInvoice) || invoiceExceptionEventsUpdated(this.props, this.state, updatedInvoice)) {
          var fakeData = {
            factor_invoice: updatedInvoice,
            factor_invoices: stateForGroup(this.props, this.state).allInvoices,
            factor_broker: stateForGroup(this.props, this.state).factorBroker,
            verification: stateForGroup(this.props, this.state).verification,
            debtor_verification_status: stateForGroup(this.props, this.state).debtorVerificationStatus
          };
          this.updateFromRemote(fakeData, this.props, 0);
        }
      }
    });
    __publicField(this, "closeDocumentBrowser", () => {
      this.setStateForGroup({ viewDocuments: false });
    });
    __publicField(this, "invoiceModuleOrDocumentBrowser", () => {
      if (stateForGroup(this.props, this.state).viewDocuments) {
        return /* @__PURE__ */ jsx("div", { className: "factor-invoice__document-browser-wrapper", children: /* @__PURE__ */ jsx(
          DocumentBrowser,
          {
            location: this.props.location,
            closeBrowser: this.closeDocumentBrowser,
            model: stateForGroup(this.props, this.state).modelForBrowser,
            documentBatch: stateForGroup(this.props, this.state).documentBatchForBrowser,
            collapseSingleGroup: true,
            allowsEditingPodStatus: false,
            canEditDocumentType: false
          }
        ) });
      } else {
        return /* @__PURE__ */ jsx(Blocker, { modalView: this.possibleModalView(), children: /* @__PURE__ */ jsxs("div", { children: [
          this.actionBar(),
          this.possibleCreateInvoice()
        ] }) });
      }
    });
    __publicField(this, "actionBar", () => {
      const actions = [];
      const ignoreInSubmissionsWorkflow = Account.currentSettings().ignore_mode !== "SubmissionsWorkflowNoIgnore";
      if (canAbandonInvoice(this.props, this.state) && ignoreInSubmissionsWorkflow) {
        actions.push({
          label: "Ignore Invoice",
          action: this.startAbandoningInvoice
        });
      }
      if (!_.isEmpty(actions)) {
        return /* @__PURE__ */ jsx(ActionBar, { actions });
      }
    });
    __publicField(this, "auditFlagEditorOrDisplay", () => {
      var auditFlags = stateForGroup(this.props, this.state).auditFlags;
      if (readOnly(factorInvoice(this.props, this.state))) {
        return /* @__PURE__ */ jsx(AuditFlagDisplay, { flags: auditFlags });
      } else {
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          AuditFlagEditor,
          {
            flags: auditFlags,
            overriddenFlags: overriddenFlags(),
            transportationClient: transportationClient(this.state),
            onFlagUpdate: this.handleSaveAuditFlags
          }
        ) });
      }
    });
    __publicField(this, "handleSaveAuditFlags", (flags) => {
      this.saveAuditFlags(flags);
    });
    __publicField(this, "saveAuditFlags", (flags) => {
      this.setStateForGroup({ auditFlags: flags }, this.props, this.saveInvoice);
    });
    __publicField(this, "markFieldDirty", (f) => {
      const existingEdited = stateForGroup(this.props, this.state).editedFields;
      existingEdited[f] = (/* @__PURE__ */ new Date()).getTime();
      this.setStateForGroup({ editedFields: existingEdited });
    });
    __publicField(this, "saveInvoice", () => {
      if (!factorInvoice(this.props, this.state)) return;
      const now = (/* @__PURE__ */ new Date()).getTime();
      var props = this.props;
      const locationData = {
        destination: stateForGroup(this.props, this.state).destinationData,
        origin: stateForGroup(this.props, this.state).originData
      };
      const params = {
        factor_invoice: factorInvoiceData(this.props, this.state),
        audit_flags: stateForGroup(this.props, this.state).auditFlags,
        location_data: locationData
      };
      if (props.documentBatchContext) {
        params.document_group_ids = _.map(
          props.model.allGroups,
          (group) => group.id
        );
        params.incomplete_document_group_ids = _.map(
          props.model.incompleteGroups(),
          (group) => group.id
        );
      }
      if (stateForGroup(this.props, this.state).savingInvoice) {
        this.setStateForGroup({ nextSave: { params, requestedAt: now } });
      } else {
        this.setStateForGroup({ savingInvoice: true });
        return Api.FactorInvoices.create(params).then((data) => {
          return this.updateFromRemote(data, props, now);
        }).catch((e) => {
          const updatedState = _.tap({ savingInvoice: false }, (state) => {
            const errorFields = _.chain(
              e.responseJSON && e.responseJSON.errors || []
            ).pluck("field").compact().value();
            if (errorFields.includes("source_invoice_amount")) {
              state.source_invoice_amount = null;
            }
          });
          this.setStateForGroup(updatedState, props, this.forceUpdate);
        });
      }
    });
    __publicField(this, "setInvoiceDateToToday", () => {
      this.setStateForGroup({ source_invoice_date: today() }, null, () => {
        this.invoiceFieldChanged();
      });
    });
    __publicField(this, "invoiceInput", (field, placeholder, type) => {
      const { value, requestChange } = this.myLinkState(field);
      return /* @__PURE__ */ jsx(
        ValueLinkTextDroppableInput,
        {
          type,
          disabled: readOnly(factorInvoice(this.props, this.state)),
          value,
          onValueChange: requestChange,
          onInput: syncUntrackedInput({ value, requestChange }),
          onBlur: this.invoiceChangeComplete,
          onKeyDown: this.keyPressNotifier(field),
          placeholder
        }
      );
    });
    __publicField(this, "geosuggestInput", (field, placeholder, type) => {
      return /* @__PURE__ */ jsx(
        GeosuggestDroppableInput,
        {
          type,
          disabled: readOnly(factorInvoice(this.props, this.state)),
          onSuggestionSelected: this.geosuggestValueSetter(field),
          types: ["geocode"],
          geosuggestClear: this.geosuggestClear(field),
          onKeyDown: this.geosuggestKeyNotifier(field),
          initialValue: stateForGroup(this.props, this.state)[field],
          nonSelect: this.nonSelect(field),
          placeholder
        }
      );
    });
    __publicField(this, "nonDroppableInvoiceInput", (field, placeholder, type) => {
      const { value, requestChange } = this.myLinkState(field);
      return /* @__PURE__ */ jsx(
        "input",
        {
          type,
          disabled: readOnly(factorInvoice(this.props, this.state)),
          value,
          onChange: (e) => requestChange(e.target.value),
          onInput: syncUntrackedInput({ value, requestChange }),
          onBlur: this.invoiceChangeComplete,
          onKeyDown: this.keyPressNotifier(field),
          placeholder
        }
      );
    });
    __publicField(this, "textAreaInput", (field) => {
      const { value, requestChange } = this.myLinkStateNotNull(field);
      return /* @__PURE__ */ jsx(
        "textarea",
        {
          onBlur: this.invoiceChangeComplete,
          onKeyDown: this.keyPressNotifier(field),
          disabled: readOnly(factorInvoice(this.props, this.state)),
          value,
          onChange: (e) => requestChange(e.target.value),
          onInput: syncUntrackedInput({ value, requestChange })
        }
      );
    });
    __publicField(this, "myLinkStateNotNull", (field) => {
      const value = stateForGroup(this.props, this.state)[field];
      return {
        value: value ? value : "",
        requestChange: (value2) => {
          this.markFieldDirty(field);
          var newState = stateForGroup(this.props, this.state);
          newState[field] = value2;
          this.setStateForGroup(newState);
          this.invoiceFieldChanged();
        }
      };
    });
    __publicField(this, "myLinkState", (field) => {
      return {
        value: stateForGroup(this.props, this.state)[field],
        requestChange: (value) => {
          this.markFieldDirty(field);
          var newState = stateForGroup(this.props, this.state);
          newState[field] = value;
          this.setStateForGroup(newState);
          this.invoiceFieldChanged();
        }
      };
    });
    __publicField(this, "geosuggestValueSetter", (field) => {
      return (suggestion) => {
        this.markFieldDirty(field);
        const locationData = mapLocationData(
          suggestion.description,
          suggestion.gmaps.address_components
        );
        if (field == "origin") {
          this.setStateForGroup({
            origin: suggestion.description,
            originData: locationData,
            origin_lat: suggestion.location.lat,
            origin_lng: suggestion.location.lng
          });
          this.invoiceFieldChanged();
        } else if (field == "destination") {
          this.setStateForGroup({
            destination: suggestion.description,
            destinationData: locationData,
            destination_lat: suggestion.location.lat,
            destination_lng: suggestion.location.lng
          });
          this.invoiceFieldChanged();
        }
      };
    });
    __publicField(this, "nonSelect", (field) => {
      const component = this;
      return {
        requestChange: (inputValue) => {
          component.markFieldDirty(field);
          component.setStateForGroup({ field: inputValue });
          if (field == "origin") {
            this.setStateForGroup({
              origin: inputValue,
              originData: null,
              origin_lat: null,
              origin_lng: null
            });
            component.invoiceFieldChanged();
          } else if (field == "destination") {
            this.setStateForGroup({
              destination: inputValue,
              destinationData: null,
              destination_lat: null,
              destination_lng: null
            });
            this.invoiceFieldChanged();
          }
        }
      };
    });
    __publicField(this, "geosuggestClear", (field) => {
      return {
        requestChange: () => {
          this.markFieldDirty(field);
          if (field == "origin") {
            this.setStateForGroup({
              origin: null,
              originData: null,
              origin_lat: null,
              origin_lng: null
            });
            this.invoiceFieldChanged();
          } else if (field == "destination") {
            this.setStateForGroup({
              destination: null,
              destinationData: null,
              destination_lat: null,
              destination_lng: null
            });
            this.invoiceFieldChanged();
          }
        }
      };
    });
    __publicField(this, "keyPressNotifier", (field) => {
      return onEnterKeyRun((event) => {
        this.invoiceFieldChanged();
        this.invoiceChangeComplete();
      });
    });
    // The geosuggest input handles the key before this runs, cancelling an Enter that
    // picks a suggestion; that pick saves once it's geocoded.
    __publicField(this, "geosuggestKeyNotifier", (field) => {
      const notifier = this.keyPressNotifier(field);
      return (event) => {
        if (!event.isDefaultPrevented()) {
          notifier(event);
        }
      };
    });
    __publicField(this, "invoiceChangeComplete", () => {
      clearTimer(this.props, this.state);
      this.saveInvoice();
    });
    __publicField(this, "invoiceFieldChanged", () => {
      this.updateTimer();
    });
    __publicField(this, "updateTimer", () => {
      clearTimer(this.props, this.state);
      this.setStateForGroup({
        pendingTimeout: window.setTimeout(this.saveInvoice, 200)
      });
    });
    __publicField(this, "possibleSavingButtons", () => {
      if (isApprovable(this.props, this.state)) {
        if (!isSaving(this.props, this.state)) {
          return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__save-buttons-container", children: [
            this.saveButtonList().map((element) => {
              return element;
            }),
            /* @__PURE__ */ jsx("div", { className: "factor-invoice__completion-context", children: possibleCompletionContext(this.props, this.state) })
          ] });
        } else {
          return /* @__PURE__ */ jsx("div", { className: "factor-invoice__save-buttons-container", children: this.saveButton() });
        }
      }
    });
    __publicField(this, "saveButtonList", () => {
      const list = _.compact([
        this.possibleSaveButton(),
        this.possibleSaveAndApproveAllButton()
      ]);
      const joinedList = [];
      list.forEach((element, i) => {
        joinedList.push(element);
        if (i + 1 !== list.length) {
          joinedList.push(joinText());
        }
      });
      return joinedList;
    });
    __publicField(this, "possibleSaveButton", () => {
      if (isSaveable(this.props, this.state))
        return /* @__PURE__ */ jsx("div", { children: this.saveButton("Save") });
    });
    __publicField(this, "possibleSaveAndApproveAllButton", () => {
      if (showSaveAndApproveAll(this.props, this.state)) {
        const count = this.state.processedInvoicesCount + 1;
        const possiblePluralized = count === 1 ? "Invoice" : "Invoices";
        return /* @__PURE__ */ jsx("div", { children: this.saveButton(`Save and Approve ${count} ${possiblePluralized}`, {
          approveAll: true
        }) });
      }
    });
    __publicField(this, "possibleCarrierInvoiceNumberInput", () => {
      if (showCarrierInvoiceNumber()) {
        return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Carrier Invoice Number" }),
          this.invoiceInput(
            "carrier_invoice_number",
            "Carrier Invoice Number",
            "text"
          )
        ] }) });
      }
    });
    __publicField(this, "saveButton", (buttonText, options = {}) => {
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "load-detail__save-and_approve button--progress",
          disabled: isSaving(this.props, this.state),
          onMouseDown: _.partial(this.saveAndMarkAsProcessed, options),
          disabledText: "Saving...",
          children: buttonText
        }
      ) });
    });
    __publicField(this, "saveAndMarkAsProcessed", (options) => {
      this.didStartSaving();
      const newOptions = { document_batch_ids: documentBatchIds(this.props) };
      newOptions.approve = options.approve;
      newOptions.approve_all = options.approveAll;
      Api.FactorInvoices.markAsProcessed(
        factorInvoice(this.props, this.state).id,
        newOptions
      ).then((data) => {
        this.setStateForGroup({
          savingInvoice: false,
          factorInvoice: data.factor_invoice
        });
        this.didComplete();
      }).catch(() => {
        this.setStateForGroup({ savingInvoice: false });
      });
    });
    __publicField(this, "didStartSaving", () => {
      this.setStateForGroup({ savingInvoice: true });
    });
    __publicField(this, "saveWithErrors", () => {
      this.setStateForGroup({ savingException: true });
      Api.FactorInvoices.markAsException(
        factorInvoice(this.props, this.state).id,
        this.props.emailId
      ).then((data) => {
        this.setStateForGroup({
          factorInvoice: data.factor_invoice,
          savingException: false
        });
        this.didComplete();
      });
    });
    __publicField(this, "savingButton", () => {
      return /* @__PURE__ */ jsx(
        DisablingButton,
        {
          disabled: stateForGroup(this.props, this.state).savingException,
          className: "button--caution",
          onClick: this.saveWithErrors,
          disabledText: "Saving...",
          children: "Save as Incomplete"
        }
      );
    });
    __publicField(this, "didComplete", () => {
      this.setStateForGroup({ sendingException: false });
      const action = nextCompletionAction({
        hasNext: Boolean(this.props.location.query["next"]),
        hasGroupCallback: Boolean(this.props.didCompleteGroup)
      });
      switch (action) {
        case "pushNext":
          push(
            this.props.location.query["next"],
            DashboardReturnParams(this.props.location)
          );
          break;
        case "delegateToGroup":
          this.props.didCompleteGroup();
          break;
        case "toDashboard":
          ToDashboardWithFilters(this.props.location, embedReturnUrl(this.props));
          break;
      }
    });
    __publicField(this, "saveAndSendException", () => {
      this.setStateForGroup({ savingException: true });
      this.cancelMatching();
      Api.FactorInvoices.markAsException(
        factorInvoice(this.props, this.state).id,
        this.props.emailId
      ).then(
        (data) => {
          this.setStateForGroup({
            factorInvoice: data.factor_invoice,
            sendingException: true,
            savingException: false
          });
        },
        () => {
          this.setStateForGroup({ savingException: false });
        }
      );
    });
    __publicField(this, "possibleSaveWithErrorsButton", () => {
      if (isSaveable(this.props, this.state) && !isApprovable(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsx("div", { className: "small-3 column", children: this.savingButton() }),
          /* @__PURE__ */ jsx("div", { className: "small-3 column", children: /* @__PURE__ */ jsx(
            DisablingButton,
            {
              disabled: stateForGroup(this.props, this.state).savingException,
              className: "factor-invoice__button-cancel button--cancel",
              onClick: this.saveAndSendException,
              disabledText: "Saving...",
              children: "Save and Send"
            }
          ) }),
          /* @__PURE__ */ jsx("div", { className: "small-4 column", children: /* @__PURE__ */ jsx("div", { className: "factor-invoice__completion-context", children: completionContext(this.props) }) })
        ] });
      }
    });
    __publicField(this, "possibleExceptionSender", (invoice) => {
      var _a;
      if (stateForGroup(this.props, this.state).sendingException && invoice.active_exceptioned_item) {
        const exceptionedItemId = invoice.active_exceptioned_item.id;
        const settings = Api.Account.currentSettings() || {};
        const load = null;
        const defaultEmail = LoadEmailCreator(
          load,
          factorInvoice(this.props, this.state),
          Auth._currentUser,
          settings.custom_exception_email_subject_template,
          settings.custom_exception_email_body_template,
          templateVariables(),
          this.state.carrier
        ).initialEmail();
        const fromReply = this.props.location.pathname.match(/factor_invoices/) && this.props.location.query.fromReply && this.props.location.query.emailId;
        const selectedGroup = this.props.model.selectedGroup;
        let documents = selectedGroup.documents;
        if (selectedGroup.relatedDocuments) {
          documents = documents.concat(selectedGroup.relatedDocuments);
        }
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          ExceptionSender,
          {
            documents,
            onComplete: this.didComplete,
            defaultEmail,
            parent: stateForGroup(this.props, this.state).email,
            parentId: this.props.location.query.emailId,
            markParentComplete: Boolean(fromReply),
            contacts: ((_a = this.state.carrier) == null ? void 0 : _a.contacts) || [],
            canCancel: true,
            cancel: this.cancelExceptionSending,
            exceptionedItemId,
            carrierInvoice: factorInvoice(this.props, this.state),
            carrier: this.state.carrier,
            multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
            customEmailTemplates: settings.custom_exception_email_templates,
            templateVariables: templateVariables()
          }
        ) });
      }
    });
    __publicField(this, "cancelExceptionSending", () => {
      this.setStateForGroup({ sendingException: false });
    });
    __publicField(this, "createInvoiceHeader", () => {
      if (isMatchingInvoices(this.props, this.state)) {
        return /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: "Match Existing or Save As Incomplete" });
      } else if (currentGroupNeedsBasicInvoiceInformation(this.props, this.state)) {
        return /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: "Find or Create Invoice" });
      } else {
        return /* @__PURE__ */ jsxs("h3", { className: "load-detail__section-header", children: [
          "Extract and Verify Information",
          /* @__PURE__ */ jsx("span", { className: "right factor-invoice__header-action", children: this.possibleMatchesButton() })
        ] });
      }
    });
    __publicField(this, "possibleMatchesButton", () => {
      if (isMatchingInvoicesOnExtract(this.props, this.state)) {
        return /* @__PURE__ */ jsx("a", { onClick: this.stopShowingMatchesOnExtract, children: "Hide Possible Matches" });
      } else {
        return /* @__PURE__ */ jsx("a", { onClick: this.showMatchesOnExtract, children: "Show Possible Matches" });
      }
    });
    __publicField(this, "debtorSelected", (factorBroker) => {
      this.markFieldDirty("factorBroker");
      this.setStateForGroup({ factorBroker }, null, () => {
        this.saveInvoice();
      });
    });
    __publicField(this, "debtorCleared", () => {
      this.markFieldDirty("factorBroker");
      this.setStateForGroup({ factorBroker: null }, null, () => {
        this.saveInvoice();
      });
    });
    __publicField(this, "createInvoiceForm", () => {
      return /* @__PURE__ */ jsx(
        WaitingSpinner,
        {
          when: stateForGroup(this.props, this.state).loadingInvoice,
          children: this.invoiceDetails()
        }
      );
    });
    __publicField(this, "onlyLoadInformation", () => {
      return /* @__PURE__ */ jsxs("div", { className: "load-detail__document-information", children: [
        this.loadInformationFormText(),
        /* @__PURE__ */ jsxs("form", { onSubmit: this.handleContinue, children: [
          this.loadInformationFields(),
          this.loadInformationActions()
        ] })
      ] });
    });
    __publicField(this, "loadInformationFormText", () => {
      if (!stateForGroup(this.props, this.state).sendingException) {
        return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__invoice-help-text", children: [
          "Enter a Debtor and ",
          requiredReferenceTypeName(this.props, this.state),
          ". If that information is missing, you can \xA0",
          /* @__PURE__ */ jsx("a", { onClick: this.startMatching, children: "continue without invoice information." })
        ] });
      }
    });
    __publicField(this, "handleContinue", (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.startMatching();
      return false;
    });
    __publicField(this, "loadInformationFields", () => {
      var carrier = this.state.carrier;
      var silo = carrier && carrier.silo;
      return /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
        /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Debtor" }),
            fieldWithHint(
              this.props,
              this.state,
              /* @__PURE__ */ jsx(
                DebtorTypeAhead,
                {
                  onSelectDebtor: this.debtorSelected,
                  autoFocus: true,
                  readOnly: readOnly(factorInvoice(this.props, this.state)),
                  onClearDebtor: this.debtorCleared,
                  silo,
                  factorBroker: stateForGroup(this.props, this.state).factorBroker
                }
              ),
              "debtor_name"
            ),
            debtorVerificationStatusComponent(
              stateForGroup(this.props, this.state).debtorVerificationStatus
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Debtor Details" }),
            debtorDetails(this.props, this.state)
          ] })
        ] }),
        possibleDebtorWarning(this.props, this.state),
        /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Load ID" }),
            fieldWithHint(
              this.props,
              this.state,
              this.invoiceInput("load_id", "Load ID", "text"),
              "load_id"
            ),
            /* @__PURE__ */ jsx("div", { children: possibleLoadIdMismatch(this.props, this.state) })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Invoice Number" }),
            fieldWithHint(
              this.props,
              this.state,
              this.invoiceInput(
                "source_invoice_number",
                "Invoice Number",
                "text"
              ),
              "invoice_number"
            )
          ] })
        ] })
      ] });
    });
    __publicField(this, "loadInformationActions", () => {
      const buttonClasses = classNames({
        "button--progress": true,
        "button--disabled": currentGroupNeedsBasicInvoiceInformation(
          this.props,
          this.state
        )
      });
      const buttonText = currentGroupNeedsBasicInvoiceInformation(
        this.props,
        this.state
      ) ? "Enter Required Information" : "Continue";
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsx("div", { className: "small-5 column", children: /* @__PURE__ */ jsx(
          "button",
          {
            disabled: currentGroupNeedsBasicInvoiceInformation(
              this.props,
              this.state
            ) || stateForGroup(this.props, this.state).sendingException,
            onClick: this.doneWithBasicInvoiceInformation,
            className: buttonClasses,
            children: buttonText
          }
        ) }),
        this.continueWithoutInformationLink()
      ] });
    });
    __publicField(this, "continueWithoutInformationLink", () => {
      if (!stateForGroup(this.props, this.state).sendingException) {
        return /* @__PURE__ */ jsx("div", { className: "small-5 column", children: /* @__PURE__ */ jsx("a", { onClick: this.handleContinue, className: "button--cancel", children: "Continue without Invoice Information" }) });
      }
    });
    __publicField(this, "doneWithBasicInvoiceInformation", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!currentGroupNeedsBasicInvoiceInformation(this.props, this.state)) {
        this.setStateForGroup({ shouldShowBasicInvoiceInformation: false });
      }
    });
    __publicField(this, "locationFields", () => {
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Origin (City, State, Zip)" }),
          this.geosuggestInput("origin", "Origin", "text")
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Destination (City, State, Zip)" }),
          this.geosuggestInput("destination", "Destination", "text")
        ] })
      ] });
    });
    __publicField(this, "matchingButtons", () => {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("div", { className: "row factor-invoice__match-forward-buttons", children: [
          /* @__PURE__ */ jsx("div", { className: "small-4 column", children: this.matchInvoiceButton() }),
          /* @__PURE__ */ jsx("div", { className: "small-3 column", children: /* @__PURE__ */ jsx("button", { className: "button--cancel", onClick: this.cancelMatching, children: "Enter Invoice Info" }) })
        ] }),
        this.saveWithErrorsButton()
      ] });
    });
    __publicField(this, "saveWithErrorsButton", () => {
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsx("div", { className: "small-3 column", children: this.savingButton() }),
        /* @__PURE__ */ jsx("div", { className: "small-3 column", children: /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabled: stateForGroup(this.props, this.state).savingException,
            className: "factor-invoice__button-cancel button--cancel",
            onClick: this.saveAndSendException,
            disabledText: "Saving...",
            children: "Save and Send"
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "small-4 column", children: /* @__PURE__ */ jsx("div", { className: "factor-invoice__completion-context", children: completionContext(this.props) }) })
      ] });
    });
    __publicField(this, "invoiceDetails", () => {
      if (isMatchingInvoices(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { className: "load-detail__document-information", children: [
          this.locationFields(),
          this.referenceFields(),
          this.extractedFields(),
          this.matchingButtons(),
          this.possibleSearchResults()
        ] });
      } else if (shouldShowBasicInvoiceInformation(this.props, this.state)) {
        return this.onlyLoadInformation();
      } else {
        return /* @__PURE__ */ jsxs("div", { className: "load-detail__document-information", children: [
          this.loadInformationFields(),
          this.amountAndFlags(),
          this.invoiceDate(),
          this.possibleBrokeredInvoiceInformation(),
          this.referenceFields(),
          this.extractedFields(),
          this.locationFields(),
          /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Notes" }),
            this.textAreaInput("notes")
          ] }) }),
          /* @__PURE__ */ jsx("div", { className: "row", children: this.possibleAuditFlags() }),
          this.possibleSavingButtons(),
          this.possibleSaveWithErrorsButton(),
          this.possibleExtractMatching()
        ] });
      }
    });
    __publicField(this, "amountAndFlags", () => {
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Amount" }),
          fieldWithHint(
            this.props,
            this.state,
            /* @__PURE__ */ jsxs("div", { className: "row collapse factor-invoice__amount-row", children: [
              /* @__PURE__ */ jsx("div", { className: "small-1 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
              /* @__PURE__ */ jsx("div", { className: "small-9 columns", children: this.invoiceInput("source_invoice_amount", "Amount", "text") })
            ] }),
            "amount"
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "small-3 column", children: /* @__PURE__ */ jsxs("label", { htmlFor: "fuel-advance-checkbox-input", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              id: "fuel-advance-checkbox-input",
              type: "checkbox",
              checked: stateForGroup(this.props, this.state).fuel_advance,
              onChange: this.fuelAdvanceClicked
            }
          ),
          "\xA0 Fuel Advance"
        ] }) }),
        /* @__PURE__ */ jsx("div", { className: "small-2 column", children: /* @__PURE__ */ jsxs("label", { htmlFor: "tonu-checkbox-input", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              id: "tonu-checkbox-input",
              type: "checkbox",
              checked: stateForGroup(this.props, this.state).tonu,
              onChange: this.tonuClicked
            }
          ),
          "\xA0 TONU"
        ] }) }),
        verificationsWorkflowEnabled() && /* @__PURE__ */ jsx("div", { className: "small-5 column", children: /* @__PURE__ */ jsxs("label", { children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              checked: stateForGroup(this.props, this.state).must_verify,
              onChange: this.mustVerifyClicked
            }
          ),
          "\xA0 Must be verified"
        ] }) })
      ] });
    });
    __publicField(this, "possibleBrokeredInvoiceInformation", () => {
      const brokerClient = this.state.carrier && this.state.carrier.broker_client;
      if (brokerClient) {
        const brokeredCarrier = stateForGroup(
          this.props,
          this.state
        ).brokeredCarrier;
        return /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
          /* @__PURE__ */ jsxs("div", { className: "row", children: [
            /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
              /* @__PURE__ */ jsx("label", { children: "Carrier" }),
              /* @__PURE__ */ jsx(
                BrokeredCarrierTypeAhead,
                {
                  onSelectBrokeredCarrier: this.brokeredCarrierSelected,
                  readOnly: readOnly(factorInvoice(this.props, this.state)),
                  onClearBrokeredCarrier: this.brokeredCarrierCleared,
                  brokeredCarrier
                }
              )
            ] }),
            brokeredCarrierDetails(this.props, this.state)
          ] }),
          this.possibleCarrierInvoiceNumberInput(),
          /* @__PURE__ */ jsxs("div", { className: "row", children: [
            /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
              /* @__PURE__ */ jsx("label", { children: "Carrier Amount" }),
              /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
                /* @__PURE__ */ jsx("div", { className: "small-1 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
                /* @__PURE__ */ jsx("div", { className: "small-9 columns", children: this.invoiceInput(
                  "carrier_amount",
                  "Carrier Amount",
                  "text"
                ) })
              ] })
            ] }),
            this.brokeredCarrierTermsView()
          ] })
        ] });
      }
    });
    __publicField(this, "brokeredCarrierSelected", (brokeredCarrier) => {
      this.setStateForGroup({ brokeredCarrier }, null, () => this.saveInvoice());
    });
    __publicField(this, "brokeredCarrierCleared", () => {
      this.setStateForGroup(
        { brokeredCarrier: null },
        null,
        () => this.saveInvoice()
      );
    });
    __publicField(this, "brokeredCarrierTermSelected", (event) => {
      const brokered_carrier_term_id = event.target.value;
      this.setStateForGroup(
        { brokered_carrier_term_id },
        null,
        () => this.saveInvoice()
      );
    });
    __publicField(this, "brokeredCarrierTermsView", () => {
      if (this.state.carrier && this.state.carrier.broker_client) {
        const currentTermId = stateForGroup(
          this.props,
          this.state
        ).brokered_carrier_term_id;
        if (this.state.brokeredCarrierTerms) {
          return /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Terms" }),
            /* @__PURE__ */ jsxs(
              "select",
              {
                onChange: this.brokeredCarrierTermSelected,
                value: currentTermId,
                children: [
                  /* @__PURE__ */ jsx("option", { value: "", children: "Please Select Term" }),
                  this.state.brokeredCarrierTerms.map((term) => /* @__PURE__ */ jsxs("option", { value: term.id, children: [
                    " ",
                    term.name,
                    " "
                  ] }, term.id))
                ]
              }
            )
          ] });
        } else {
          return /* @__PURE__ */ jsx("span", { children: "Loading..." });
        }
      } else {
        return null;
      }
    });
    __publicField(this, "invoiceDate", () => {
      if (Account.current().settings.factor_use_source_invoice_date) {
        return /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
            /* @__PURE__ */ jsx("label", { children: "Invoice Date" }),
            fieldWithHint(
              this.props,
              this.state,
              this.nonDroppableInvoiceInput(
                "source_invoice_date",
                "Invoice Date",
                "date"
              ),
              "invoice_date"
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: "small-5 column", children: /* @__PURE__ */ jsx(
            "a",
            {
              onClick: this.setInvoiceDateToToday,
              className: "factor-invoice__button-today",
              disabled: readOnly(factorInvoice(this.props, this.state)),
              children: "Today"
            }
          ) })
        ] });
      }
    });
    __publicField(this, "possibleAuditFlags", () => {
      if (Account.current().settings.factor_use_audit_flags) {
        return /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsxs("label", { children: [
            "Audit Flags \xA0",
            possibleReviewLink(this.props, this.state)
          ] }),
          this.auditFlagEditorOrDisplay()
        ] });
      }
    });
    __publicField(this, "possibleCreateInvoice", () => {
      return /* @__PURE__ */ jsxs("div", { children: [
        possibleOtherInvoices(this.props, this.state),
        possibleSourceSystemWarning(this.props, this.state),
        possibleIgnoreProcessedMessage(this.props, this.state),
        this.possibleReadOnlyMessage(),
        this.possibleCloseReplyButton(),
        this.possibleExceptionArea(),
        this.possibleSavingButtons(),
        this.possibleSaveWithErrorsButton(),
        this.possibleUnIgnoreButton(),
        this.possibleReturnToDashboardOrNextGroupButton(),
        this.possibleVerifications(),
        possiblePaymentsNetworkLoad(this.props, this.state),
        this.createInvoiceHeader(),
        this.createInvoiceForm()
      ] });
    });
    __publicField(this, "possibleVerifications", () => {
      if ((verificationsEnabled() || this.props.location.query.verificationsSneakPeek == "true") && stateForGroup(this.props, this.state).verification && !stateForGroup(this.props, this.state).verification.hide_display) {
        const verification = stateForGroup(this.props, this.state).verification;
        const verdict = verificationVerdict(verification.state);
        if (paymentsNetworkEnabled()) {
          return this.possibleVerificationsAlternateView(verification, verdict);
        } else {
          return /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
            /* @__PURE__ */ jsxs("h3", { className: "load-detail__section-header", children: [
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: "verification__verdict-indicator verification__verdict-indicator--" + verdict.severity
                }
              ),
              "Broker Verification: ",
              verdict.label,
              this.possibleVerificationDetailsButton(verification)
            ] }),
            possibleVerificationDetails(
              this.props,
              this.state,
              verification.disclosure_details
            )
          ] });
        }
      }
    });
    __publicField(this, "possibleVerificationsAlternateView", (verification, verdict) => {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("h2", { className: "load-detail__section-header", children: [
          "Debtor verifications",
          this.alternateVerificationShowDetailsButton(verification),
          /* @__PURE__ */ jsx("span", { children: "\xA0" }),
          possibleVerificationDataSourceTooltip(
            this.props,
            this.state,
            verification
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: "load-detail__debtor-verification-detail-labels load-detail__debtor-verification-detail-labels--" + verdict.severity,
              children: [
                /* @__PURE__ */ jsx("i", { className: verdict.glyph, "aria-hidden": "true" }),
                verdict.label
              ]
            }
          )
        ] }),
        alternateVerificationDetails(this.props, this.state, verification)
      ] });
    });
    __publicField(this, "alternateVerificationShowDetailsButton", (verification) => {
      const verb = isShowingVerificationDetails(this.props, this.state) ? "Hide" : "Show";
      const icon = isShowingVerificationDetails(this.props, this.state) ? "fi-minus" : "fi-plus";
      return /* @__PURE__ */ jsx("span", { className: "right factor-invoice__header-action show-verifications-toggle", children: /* @__PURE__ */ jsxs("a", { onClick: this.toggleVerificationDetails, children: [
        verb,
        " Details\xA0",
        /* @__PURE__ */ jsx("i", { className: icon })
      ] }) });
    });
    __publicField(this, "possibleVerificationDetailsButton", (verification) => {
      if (verification.state != "success" && verification.disclosure_details) {
        const verb = isShowingVerificationDetails(this.props, this.state) ? "Hide" : "Show";
        return /* @__PURE__ */ jsx("span", { className: "right factor-invoice__header-action", children: /* @__PURE__ */ jsxs("a", { onClick: this.toggleVerificationDetails, children: [
          verb,
          " Details"
        ] }) });
      }
    });
    __publicField(this, "possibleCloseReplyButton", () => {
      if (approvedInvoiceReplyEmail(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(
            CloseReply,
            {
              emailId: this.props.location.query.emailId,
              onComplete: this.didComplete
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "load-detail__completion-context", children: "and return to the Dashboard" })
        ] });
      }
    });
    __publicField(this, "reject", () => {
      this.setStateForGroup({ rejecting: true });
      FactorInvoicesService.rejectInvoice(
        factorInvoice(this.props, this.state).id
      ).then((rejectedInvoice) => {
        const factorInvoices = _.chain(
          stateForGroup(this.props, this.state).allInvoices
        ).reject((inv) => inv.id == rejectedInvoice.id).concat(rejectedInvoice).value();
        this.updateFromRemote(
          {
            factor_invoice: rejectedInvoice,
            factor_invoices: factorInvoices,
            factor_broker: stateForGroup(this.props, this.state).factorBroker
          },
          void 0,
          0
        );
      }).then(() => this.setStateForGroup({ rejecting: false }));
    });
    __publicField(this, "possibleRejectLink", () => {
      if (stateForGroup(this.props, this.state).rejecting) {
        return /* @__PURE__ */ jsx("div", { children: "Rejecting..." });
      } else {
        return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__invoice-help-text", children: [
          "This invoice has been marked processed.\xA0",
          /* @__PURE__ */ jsx("a", { onClick: this.reject, children: "Reject it" }),
          " if you need to make changes."
        ] });
      }
    });
    __publicField(this, "possibleReadOnlyMessage", () => {
      if (isHubtranInvoice(this.props, this.state) && !stateForGroup(this.props, this.state).loadingInvoice) {
        if (readOnly(factorInvoice(this.props, this.state))) {
          if (canReject(this.props, this.state)) {
            return this.possibleRejectLink();
          } else {
            let message = "This invoice has been marked approved and cannot be changed.  Contact support if you need to make changes.";
            if (factorInvoice(this.props, this.state).state == "abandoned") {
              message = "This invoice has been ignored.  Un-Ignore it to make changes";
            } else if (factorInvoice(this.props, this.state).source_system != "hubtran") {
              message = "This invoice has been imported from the TMS, and cannot be edited";
            }
            return /* @__PURE__ */ jsx("div", { className: "factor-invoice__invoice-help-text", children: message });
          }
        }
      }
    });
    __publicField(this, "possibleUnIgnoreButton", () => {
      var isAbandoned = loadHelper.isAbandoned(
        factorInvoice(this.props, this.state)
      );
      if (isAbandoned) {
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabled: this.state.isUnIgnoring,
            className: "button--progress",
            onClick: this.revive,
            disabledText: "Un-Ignoring...",
            children: "Un-Ignore This Invoice"
          }
        );
      }
    });
    __publicField(this, "possibleReturnToDashboardOrNextGroupButton", () => {
      var isAbandoned = loadHelper.isAbandoned(
        factorInvoice(this.props, this.state)
      );
      if (isAbandoned) {
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabled: this.state.isUnIgnoring,
            className: "button--progress load-detail__return-to-dashboard-button",
            onClick: this.didComplete,
            disabledText: "Un-Ignoring...",
            children: this.props.hasMore ? "Go To Next Group" : "Return To Dashboard"
          }
        );
      }
    });
    __publicField(this, "revive", () => {
      const invoiceId = factorInvoice(this.props, this.state).id;
      this.setState({ isUnIgnoring: true });
      Api.FactorInvoices.revive(invoiceId).then(
        () => this.setState({ isUnIgnoring: false })
      );
    });
    __publicField(this, "possibleExceptionArea", () => {
      return /* @__PURE__ */ jsxs("div", { children: [
        this.possibleExceptionSender(factorInvoice(this.props, this.state)),
        possibleRulesAndExceptions(
          this.props,
          this.state,
          factorInvoice(this.props, this.state)
        )
      ] });
    });
    __publicField(this, "showMatchesOnExtract", () => {
      return this.setStateForGroup({ matchingInvoicesOnExtract: true });
    });
    __publicField(this, "stopShowingMatchesOnExtract", () => {
      return this.setStateForGroup({ matchingInvoicesOnExtract: false });
    });
    __publicField(this, "startMatching", () => {
      if (this.props.onContinueWithoutInvoiceInformation) {
        this.props.onContinueWithoutInvoiceInformation(true);
      }
      return this.setStateForGroup({ matchingInvoices: true });
    });
    __publicField(this, "cancelMatching", () => {
      if (this.props.onContinueWithoutInvoiceInformation) {
        this.props.onContinueWithoutInvoiceInformation(false);
      }
      return this.setStateForGroup({ matchingInvoices: false });
    });
    __publicField(this, "extractMatchingButtons", () => {
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsx("div", { className: "small-5 column", children: this.matchInvoiceButton() }),
        /* @__PURE__ */ jsx("div", { className: "small-5 column", children: /* @__PURE__ */ jsx(
          "button",
          {
            className: "button--cancel",
            onClick: this.stopShowingMatchesOnExtract,
            children: "Hide Possible Matches"
          }
        ) })
      ] });
    });
    __publicField(this, "toggleVerificationDetails", () => {
      const current = isShowingVerificationDetails(this.props, this.state);
      this.setStateForGroup({ showingVerificationDetails: !current });
    });
    __publicField(this, "possibleExtractMatching", () => {
      if (isMatchingInvoicesOnExtract(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
          this.extractMatchingButtons(),
          this.possibleSearchResults()
        ] });
      }
    });
    __publicField(this, "possibleSearchResults", () => {
      if (stateForGroup(this.props, this.state).searchResults) {
        if (_.isEmpty(stateForGroup(this.props, this.state).searchResults)) {
          return noResultsFound();
        } else {
          return this.searchResults();
        }
      }
    });
    __publicField(this, "searchResults", () => {
      return /* @__PURE__ */ jsxs("div", { className: "factor-invoice__search-container", children: [
        searchSectionHeader(),
        searchResultsHeader(),
        this.mapSearchResults(
          stateForGroup(this.props, this.state).searchResults
        )
      ] });
    });
    __publicField(this, "openDocumentBrowser", (documentBatchesIds, invoice) => {
      DocumentsService.getDocumentBatches(documentBatchesIds).then(
        (documentBatches) => {
          var invoiceId = invoice.id;
          var model = modelForSearch(documentBatches, invoiceId);
          this.setStateForGroup({
            modelForBrowser: model,
            viewDocuments: true,
            documentBatchForBrowser: documentBatches[0] || null
          });
        }
      );
    });
    __publicField(this, "mapSearchResults", (results) => {
      return _.map(results, (result) => {
        const invoice = result.factor_invoice;
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: "row factor-invoice__search-items-container",
            children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
              /* @__PURE__ */ jsx("div", { className: "small-1 column factor_invoice__search-item", children: /* @__PURE__ */ jsx(
                "input",
                {
                  type: "radio",
                  value: invoice.id,
                  checked: parseInt(
                    stateForGroup(this.props, this.state).selectedFactorInvoiceId
                  ) === parseInt(invoice.id),
                  onChange: this.onSelectedInvoiceChanged
                }
              ) }),
              /* @__PURE__ */ jsxs("div", { className: "small-3 column factor_invoice__search-item", children: [
                invoiceEmailSubject(invoice),
                /* @__PURE__ */ jsx("br", {}),
                invoiceEmailDate(invoice)
              ] }),
              /* @__PURE__ */ jsx("div", { className: "small-3 column factor_invoice__search-item", children: invoiceInformation(result) }),
              /* @__PURE__ */ jsx("div", { className: "small-3 column factor_invoice__search-item", children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: "factor-invoice__documents-icon",
                  onClick: _.partial(
                    this.openDocumentBrowser,
                    invoice.document_batch_ids,
                    invoice
                  ),
                  children: /* @__PURE__ */ jsx("div", { className: "factor-invoice__documents-count", children: documentTypesForInvoice(invoice).join(", ") })
                }
              ) })
            ] })
          },
          "factor-invoice__" + invoice.id
        );
      });
    });
    __publicField(this, "onSelectedInvoiceChanged", (e) => {
      this.setStateForGroup({ selectedFactorInvoiceId: e.currentTarget.value });
    });
    __publicField(this, "tonuClicked", (e) => {
      this.markFieldDirty("tonu");
      this.setStateForGroup(
        { tonu: e.currentTarget.checked },
        null,
        this.saveInvoice
      );
    });
    __publicField(this, "fuelAdvanceClicked", (e) => {
      this.markFieldDirty("fuel_advance");
      this.setStateForGroup(
        { fuel_advance: e.currentTarget.checked },
        null,
        this.saveInvoice
      );
    });
    __publicField(this, "mustVerifyClicked", (e) => {
      this.markFieldDirty("must_verify");
      this.setStateForGroup(
        { must_verify: e.currentTarget.checked },
        null,
        this.saveInvoice
      );
    });
    __publicField(this, "matchInvoiceButton", () => {
      return /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "load-detail__save-and-approve button--progress",
          disabled: !stateForGroup(this.props, this.state).selectedFactorInvoiceId || stateForGroup(this.props, this.state).assigningDocuments,
          onClick: this.assignDocumentsToSelectedInvoice,
          disabledText: stateForGroup(this.props, this.state).assigningDocuments ? "Assigning..." : "Select Invoice to Match",
          children: "Assign Selected Invoice's Documents to This Invoice"
        }
      );
    });
    __publicField(this, "assignDocumentsToSelectedInvoice", () => {
      const selectedFactorInvoiceId = stateForGroup(
        this.props,
        this.state
      ).selectedFactorInvoiceId;
      const mergedFactorInvoiceIds = stateForGroup(
        this.props,
        this.state
      ).mergedFactorInvoiceIds;
      if (mergedFactorInvoiceIds.indexOf(selectedFactorInvoiceId) !== -1) {
        return;
      }
      this.setStateForGroup({
        assigningDocuments: true,
        mergedFactorInvoiceIds: mergedFactorInvoiceIds.concat([
          selectedFactorInvoiceId
        ])
      });
      const props = this.props;
      Api.FactorInvoices.mergeInvoices(
        factorInvoice(this.props, this.state).id,
        selectedFactorInvoiceId
      ).then((data) => {
        this.setStateForGroup(
          {
            assigningDocuments: false,
            searchingInvoices: false,
            matchingInvoices: false,
            continueWithoutInvoiceInformation: false
          },
          null,
          () => {
            this.updateFromRemote(data, props, (/* @__PURE__ */ new Date()).getTime());
          }
        );
      }).then(this.props.onMergeDocumentBatches).catch(() => {
        this.setStateForGroup({
          assigningDocuments: false,
          mergedFactorInvoiceIds: stateForGroup(
            this.props,
            this.state
          ).mergedFactorInvoiceIds.filter(
            (id) => id !== selectedFactorInvoiceId
          )
        });
      });
    });
    __publicField(this, "invoiceUpdated", () => {
      this.searchInvoices();
    });
    __publicField(this, "searchInvoices", (invoiceId) => {
      if (this.mounted && carrierId(this.state)) {
        this.setStateForGroup({
          searchResults: null,
          selectedFactorInvoiceId: null,
          loadingSearchResults: true
        });
        Api.FactorInvoices.searchInvoices(
          buildSearchParams(this.props, this.state, invoiceId)
        ).then((results) => {
          results = _.reject(results, (result) => {
            return result.factor_invoice.id === (factorInvoice(this.props, this.state) && factorInvoice(this.props, this.state).id);
          });
          this.setStateForGroup({
            searchResults: results,
            loadingSearchResults: false
          });
        });
      }
    });
    __publicField(this, "referenceFields", () => {
      var mapReference = (value, referenceIndex) => {
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: "small-5 column",
            children: [
              /* @__PURE__ */ jsx("label", { children: "Reference" }),
              /* @__PURE__ */ jsx(
                TextDroppableInput,
                {
                  type: "text",
                  onDrop: this.referenceChangedHandlerForIndex(referenceIndex),
                  readOnly: readOnly(factorInvoice(this.props, this.state)),
                  onChange: this.referenceChangedHandlerForIndex(referenceIndex),
                  onBlur: this.invoiceChangeComplete,
                  onKeyDown: onEnterKeyRun(this.invoiceChangeComplete),
                  value
                }
              )
            ]
          },
          "reference_internal_row_" + referenceIndex
        );
      };
      return _.map(
        asPairs(stateForGroup(this.props, this.state).references || ["", ""]),
        (pair, pairIndex) => {
          return /* @__PURE__ */ jsx("div", { className: "row", children: _.map(pair, (reference, pairOffset) => {
            return mapReference(reference, 2 * pairIndex + pairOffset);
          }) }, "reference_field_row_" + pairIndex);
        }
      );
    });
    __publicField(this, "extractedFields", () => {
      const invoice = factorInvoice(this.props, this.state);
      if (invoice) {
        return /* @__PURE__ */ jsx(
          ExtractedFields,
          {
            fieldsSourceObject: invoice.extracted_fields,
            sourceId: invoice.id,
            extractedFields: extractedFieldsFields(this.props, this.state),
            onChange: this.extractedFieldsChanged
          }
        );
      }
    });
    __publicField(this, "extractedFieldsChanged", (updatedFields) => {
      this.markFieldDirty("extracted_fields");
      this.setStateForGroup({ extracted_fields: updatedFields });
      this.invoiceFieldChanged();
    });
    __publicField(this, "referenceChangedHandlerForIndex", (i) => {
      return (event, value) => {
        if (value && escapeRegExp(value).match(/reference_field_row.+reference_internal_row/)) {
          return;
        }
        this.markFieldDirty("references");
        var current_references = stateForGroup(this.props, this.state).references;
        var new_references = current_references ? current_references.splice(0) : ["", ""];
        new_references[i] = "" + (value || event.currentTarget.value);
        this.setStateForGroup({
          references: ensureReferencesHaveCorrectPadding(new_references)
        });
        this.invoiceFieldChanged();
      };
    });
    __publicField(this, "startAbandoningInvoice", () => {
      this.setState({ abandoningInvoice: true });
    });
    __publicField(this, "abandonInvoice", (reason) => {
      return Api.FactorInvoices.abandon(
        factorInvoice(this.props, this.state).id,
        reason
      ).then(this.props.factorInvoiceAbandonedCallback).then(() => {
        this.setState({ abandoningInvoice: false });
      }).catch(console.error);
    });
    __publicField(this, "possibleModalView", () => {
      if (this.state.abandoningInvoice) {
        return /* @__PURE__ */ jsx(
          InvoiceAbandoner,
          {
            abandon: this.abandonInvoice,
            onCancel: () => this.setState({ abandoningInvoice: false })
          }
        );
      }
    });
  }
  componentDidMount() {
    var _a, _b;
    this.mounted = true;
    $(FactorInvoicesStore).on(
      storeChangedEvent("FactorInvoices"),
      this.invoiceStoreUpdated
    );
    const shouldSendException = ((_b = (_a = this.props.location) == null ? void 0 : _a.query) == null ? void 0 : _b.sendException) === "true";
    if (shouldSendException) {
      const url = new URL(window.location.href);
      url.searchParams.delete("sendException");
      const { history } = window;
      history.replaceState({}, "", url.toString());
    }
    this.props.carrier.then((carrier) => {
      if (!carrier) {
        Honeybadger.notify({
          message: "Carrier promise resolved to undefined in factor invoice",
          context: {
            factorInvoiceId: this.props.params.factorInvoiceId,
            groupID: this.props.groupID
          },
          fingerprint: "factor-invoice-carrier-undefined"
        });
      }
      return new Promise((resolve) => {
        this.setState({ carrier }, resolve);
      });
    }).then(() => this.loadDataForCurrentGroup(this.props, this.state.pusher)).then(() => {
      if (shouldSendException) {
        this.setStateForGroup({ sendingException: true });
      }
    }).then(this.fetchBrokeredCarrierTerms).catch((error) => {
      Honeybadger.notify({
        message: "Error loading carrier data in factor invoice",
        context: {
          factorInvoiceId: this.props.params.factorInvoiceId,
          groupID: this.props.groupID,
          error: error.toString()
        },
        fingerprint: "factor-invoice-carrier-load-error"
      });
    });
    $(FactorInvoiceUpdateService).on(
      "FactorInvoiceUpdateService:invoiceUpdated",
      this.invoiceUpdated
    );
    $(DataStoreService).on(
      "DataStoreService:factorInvoiceUpdated",
      this.invoiceStoreUpdated
    );
    $(presenceService).on(
      "presence_service:invoiceCreated",
      this.invoiceCreated
    );
    this.updateProcessedInvoicesCount({});
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.documentBatches !== prevProps.documentBatches) {
      this.updateProcessedInvoicesCount(prevState);
    }
    if (prevProps.groupID !== this.props.groupID || !_.isEqual(prevProps.activeDocuments, this.props.activeDocuments)) {
      if (prevProps.onContinueWithoutInvoiceInformation) {
        this.setStateForGroup({ matchingInvoices: false }, prevProps);
        prevProps.onContinueWithoutInvoiceInformation(false);
      }
      this.loadDataForCurrentGroup(this.props);
    }
    if (this.props.factorInvoiceId && prevProps.factorInvoiceId !== this.props.factorInvoiceId) {
      this.grabInvoiceFromApi(this.props.factorInvoiceId, this.props, true);
    }
    const { factorInvoiceId, lastDocumentSaveTime } = this.props;
    if (lastDocumentSaveTime && prevProps.lastDocumentSaveTime !== lastDocumentSaveTime && factorInvoiceId) {
      this.grabInvoiceFromApi(factorInvoiceId, this.props).catch((error) => {
        Honeybadger.notify(error, {
          context: {
            message: "Failed to refetch invoice after document save",
            factorInvoiceId,
            lastDocumentSaveTime
          }
        });
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    $(DataStoreService).off(
      "DataStoreService:factorInvoiceUpdated",
      this.invoiceStoreUpdated
    );
    $(FactorInvoicesStore).off(
      "storeChanged:FactorInvoices",
      this.invoiceStoreUpdated
    );
    $(FactorInvoiceUpdateService).off(
      "FactorInvoiceUpdateService:invoiceUpdated",
      this.invoiceUpdated
    );
    $(presenceService).off(
      "presence_service:invoiceCreated",
      this.invoiceCreated
    );
    FactorInvoiceUpdateService.unsubscribeFromAllChannels(this.state.pusher);
  }
  render() {
    return /* @__PURE__ */ jsx("div", { "data-component": "FactorInvoice", children: this.invoiceModuleOrDocumentBrowser() });
  }
}
export default FactorInvoice;
